<template>
	<div>
		<CList :pConfigList="ConfigList" :segurity="segurity">
			<template slot="bodyForm">
				<CLoader :pConfigLoad="ConfigLoad">
					<template slot="BodyFormLoad">
						<input type="hidden" :value="autoSuma">
						<input type="hidden" :value="autoValidador">
						<div class="">
							<form id="FormPedido" role="form" method="post" autocomplete="off" onSubmit="return false">

								<div class="row mt-2">
									<div class="col-12">
										<div class="card">
											<div class="card-body">
												<h5 class="card-title">Datos Generales</h5>

												<div class="row">
													<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
														<label class="form-label">Clave</label><!-- ESPACIADOR DE ALTURA EN BLANCO -->
														<div class="input-group mb-3">
															<input type="text" @keyup.enter="getClientebyClave()" v-model="objCliente.Clave" class="form-control" placeholder="Buscar por Clave" :disabled="bndClientebyName">
															<button v-if="!bndClienteReady" @click="getClientebyClave()" class="btn btn-search btn-primary" type="button" id="button-addon2"><i class="fa fa-search"></i></button>
															<button v-if="bndClienteReady" @click="Limpiar()" class="btn btn-search btn-warning" type="button" id="button-addon2"><i class="fa fa-trash"></i></button>
														</div>
													</div>

													<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
														<template v-if="bndClientebyKey">
															<label class="form-label" for="NombreCliente">*Cliente</label>
															<input type="text" v-model="objCliente.Nombre" class="form-control" id="NombreCliente" placeholder="" readonly />
														</template>
														<BuscadorCliente v-if="!bndClientebyKey"
															ref="buscadorCliente"
															:ptextLabel="'*Cliente'"
															@input="getCliente()"
															v-model="objCliente.IdCliente">
															<CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*' + errorvalidacion.IdCliente[0]"/>
														</BuscadorCliente>
													</div>

													<div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-3">
														<label class="form-label" for="Rfc">RFC</label>
														<input type="text" v-model="objCliente.Rfc" class="form-control" id="Rfc" placeholder="" readonly />
													</div>

													<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
														<label class="form-label" for="DireccionCliente">Dirección</label>
														<input type="text" v-model="objCliente.Direccion" class="form-control" id="DireccionCliente" placeholder="" readonly />
													</div>
			
												</div>

												<div class="row">

													<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
														<label class="form-label" for="Paciente">Paciente</label>
														<input type="text" v-model="objPedido.Paciente" class="form-control" id="Paciente" placeholder="Ingresar Paciente" />
														<CValidation v-if="this.errorvalidacion.Paciente" :Mensaje="'*'+errorvalidacion.Paciente[0]"/>
													</div>
													
													<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"></div>
												</div>

											</div>
										</div>
									</div>
								</div>

								<div class="row mt-4" id="lenteConfig">
									<div class="col-12">

										
										<div  class="card">
											<div class="card-body">
												<!-- PASO 1 -->
												<div v-if="showPasos.paso1">

													<h5 class="card-title">Seleccion de Lente</h5>

													<!-- ************************ BLOQUE FUNCIONAL SOLO PARA PROCESO #1 ************************ -->


													<!-- SELECTOR DE TIPO DE LENTE (PROCESO 1) -->
													<div class="row mt-2">
														<h6>Tipo de Lente</h6>
														<div v-show="parseInt(objPedido.IdCliente) != 0" class="col-auto" v-for="(item2,idextplente2) in ListaTipoLentes" :key="idextplente2">
															<div class=" form-check-inline form-check form-switch form-sw">
																<input v-model="objPedido.IdTipoLente" @change="selectorProceso()" class="form-check-input" type="radio" role="switch" :value="item2.IdTipoLente" :id="'idswitchplente'+item2.IdTipoLente" >
																<label class="form-check-label" for="flexSwitchCheckDefault">{{ item2.Nombre }}</label>
															</div>
														</div>
														<CValidation v-if="this.errorvalidacion.IdTipoLente" :Mensaje="'*'+errorvalidacion.IdTipoLente[0]"/>

														<div v-show="parseInt(objPedido.IdCliente) == 0" class="col-auto">
															<div class="alert alert-info" role="alert">
																Necesita seleccionar un cliente para continuar.
															</div>
														</div>
													</div>
												
													<!---- CONFIGRACION DE VALORES PARA LENTES RX ---->
													<span id="confTablaRX"></span>
													<template v-if="parseInt(objPedido.IdTipoLente) > 0 && showRXLentes">
														
														<!---- OJO LADO DERECHO ---->
														<div class="row mt-4">
															<h6>Medidas RX</h6>

															<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
																<div class="form-check form-switch">
																	<input v-model="objPedido.OjoDerecho" @change="limpiaRXDerecho()" class="form-check-input" type="checkbox" role="switch" id="OjoDerecho">
																	<label class="form-check-label" for="OjoDerecho">RX Ojo Derecho</label>
																</div>
															</div>
														</div>

														<div v-if="objPedido.OjoDerecho" class="row mt-1">

															<!-- ESFERA DERECHA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdEsfera">Esfera</label>
																<input type="text" v-model="objPedido.OdEsfera" 
																	@keyup.enter="validaRangosRX('Esfera','OdEsfera')"
																	@blur="validaRangosRX('Esfera','OdEsfera')"
																	@input="$numberosPermitidos($event,objPedido,'OdEsfera'); accionInput('OdEsfera','Esfera');"
																	:style="EsferaDerecha.showTool ? 'border-color:red;' :''"
																	class="form-control" id="OdEsfera"/>
																
																<b-tooltip id="tooltip_OdEsfera" :show.sync="EsferaDerecha.showTool" target="OdEsfera" placement="right"> Indique valores <strong>(+/-)</strong> </b-tooltip>

																<b-popover id="popover_OdEsfera" :disabled="true" custom-class="IzEsferas" :show.sync="EsferaDerecha.showPopOver" target="OdEsfera" ref="popOdEsfera" placement="top" @hidden="onHidden()">
																	<template #title>
																		<b-button @click="onClose('OdEsfera','Esfera')" class="close c-pop" aria-label="Close">
																			<i class="fas fa-times text-black"></i>
																		</b-button>
																		Selecciona una Graduación
																	</template>
																	
																	<span>
																		<div class="row" id="OdEsferaPopContener">
																			<div v-for="(item1,index1) in EsferaDerecha.listaMedidas" :key="index1+'_OdEf'" class="col-4 col-sm-4 col-md-3 col-lg-3 text-center">
																				<button @click="getCheckValores('Esfera','OdEsfera',item1.Valor)" type="button" class="btn btn-primary" :id="index1+'_btnOdEf'"
																					style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item1.Valor }}</button>
																			</div>	
																		</div>
																	</span>

																</b-popover>
			
															</div>

															<!-- CILINDRO DERECHO -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdCilindro">Cilindro</label>
																<input type="text" v-model="objPedido.OdCilindro" 
																	@keyup.enter="validaRangosRX('Cilindro','OdCilindro')" 
																	@blur="validaRangosRX('Cilindro','OdCilindro')" 
																	@input="$numberosPermitidos($event,objPedido,'OdCilindro'); accionInput('OdCilindro','Cilindro')"
																	:style="CilindroDerecho.showTool ? 'border-color:red;' :''" 
																	class="form-control" id="OdCilindro"/>


																<b-tooltip id="tooltip_OdCilindro" :show.sync="CilindroDerecho.showTool" target="OdCilindro" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

																<b-popover :disabled="true" :show.sync="CilindroDerecho.showPopOver" target="OdCilindro" ref="popOdCilindro" placement="top" @hidden="onHidden()">
																	<template #title>
																		<b-button type="button" @click="onClose('OdCilindro','Cilindro')" class="close c-pop" aria-label="Close">
																			<i class="fas fa-times text-black"></i>
																		</b-button>
																		Selecciona una Graduación
																	</template>

																	<span >
																		<div class="row" id="OdCilindroPopContener">
																			<div v-for="(item2,index2) in CilindroDerecho.listaMedidas" :key="index2+'_OdCl'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																				<button @click="getCheckValores('Cilindro','OdCilindro',item2.Valor)" type="button" class="btn btn-primary" :id="index2+'OdCl'"
																				style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item2.Valor }}</button>
																			</div>	
																		</div>
																	</span>

																</b-popover> 
																
															</div>

															<!-- EJE -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdEje">Eje</label>
																<input @input="$onlyNums($event,objPedido,'OdEje'), validaRangosRX('Eje','OdEje')" type="text" v-model="objPedido.OdEje" class="form-control" id="OdEje"
																:style="toolTipRX.showToolOdEje || toolTipRX.showToolOdEjeRequire ? 'border-color:red;' :''" 
																:readonly="CilindroDerecho.blockEje"/>
																<center><label id="lblodeje">0 - 180</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdEje" target="OdEje" placement="top"> Rango unicamente de 0 a 180</b-tooltip>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdEjeRequire" target="OdEje" placement="top"> Campo Obligatorio</b-tooltip>
															</div> 

															<!-- RANGO ADICIONAL DERECHA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdAdicion">*Adición</label>
																<input type="text" v-model="objPedido.OdAdicion" 
																	@keyup.enter="validaRangosRX('RangoAdicional','OdAdicion')" 
																	@blur="validaRangosRX('RangoAdicional','OdAdicion')" 
																	@input="$numberosPermitidos($event,objPedido,'OdAdicion'), accionInput('OdAdicion','RangoAdicional')"
																	:style="RanAdicionalDerecho.showTool ? 'border-color:red;' :''"
																	class="form-control" id="OdAdicion" :readonly="TpLenteSelect.Adicion == 'NO'"/>

																	<b-tooltip id="tooltip_OdAdicion" :show.sync="RanAdicionalDerecho.showTool" target="OdAdicion" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>
																	<b-popover id="popover_OdAdicion" :disabled="true"  :show.sync="RanAdicionalDerecho.showPopOver" target="OdAdicion" ref="popOdAdicion" placement="top" @hidden="onHidden()">
																		<template #title>
																			<button type="button" @click="onClose('OdAdicion','RangoAdicional')" class="close c-pop" aria-label="Close">
																				<i class="fas fa-times text-black"></i>
																			</button>
																			Selecciona una Graduación
																		</template>

																		<span >
																			<div class="row" id="OdAdicionPopContener">
																				<div v-for="(item3,index3) in RanAdicionalDerecho.listaMedidas" :key="index3+'_OdRg'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																					<button @click="getCheckValores('RangoAdicional','OdAdicion',item3.Valor)" type="button" class="btn btn-primary" :id="index3+'_btnOdRg'"
																					style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item3.Valor }}</button>
																				</div>	
																			</div>
																		</span>

																	</b-popover>
																
																
															</div>
															<!-- ALTO DE MONTURA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdAltMon">*Alt. Mon</label>
																<input @input="$onlyNums($event,objPedido,'OdAltMon')" @change="validaRangosRX('AltMont','OdAltMon')" type="text" v-model="objPedido.OdAltMon" :style="toolTipRX.showToolOdAltMon ? 'border-color:red;' :''" 
																	class="form-control" id="OdAltMon" :readonly="TpLenteSelect.AltMon == 'NO'" />
																<center><label id="lblodaltmon">{{TpLenteSelect.ValMinMon}} - {{ TpLenteSelect.ValMaxMon }}</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdAltMon" target="OdAltMon" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinMon}} a {{ TpLenteSelect.ValMaxMon }}</b-tooltip>
															</div>

															<!-- ALTO DE SEGMENTO -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdAltSeg">Alt. Seg.</label>
																<input  @input="$onlyNums($event,objPedido,'OdAltSeg')" @change="validaRangosRX('AltSeg','OdAltSeg')" type="text" v-model="objPedido.OdAltSeg" :style="toolTipRX.showToolOdAltSeg ? 'border-color:red;' :''" 
																	class="form-control" id="OdAltSeg" :readonly="TpLenteSelect.AltSeg == 'NO'" />
																<center><label id="lblodaltseg">{{TpLenteSelect.ValMinSeg}} - {{ TpLenteSelect.ValMaxSeg }}</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdAltSeg" target="OdAltSeg" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinSeg}} a {{ TpLenteSelect.ValMaxSeg }}</b-tooltip>
															</div>

															<!-- DNP -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdDnp">*DNP</label>
																<input @input="$onlyNums($event,objPedido,'OdDnp')" @change="validaRangosRX('Dnp','OdDnp')" type="text" v-model="objPedido.OdDnp" :style="toolTipRX.showToolOdDnp ? 'border-color:red;' :''" 
																	class="form-control" id="OdDnp" />
																<center><label id="lbloddnp">20 - 50</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdDnp" target="OdDnp" placement="top"> Rango unicamente de 20 a 50</b-tooltip>
															</div>

															<!-- PRISMA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OdPrisma">Prisma</label>
																<input @input="$onlyNums($event,objPedido,'OdPrisma'), validaRangosRX('Prisma','OdPrisma')" type="text" v-model="objPedido.OdPrisma" :style="toolTipRX.showToolOdPrisma ? 'border-color:red;' :''" 
																	class="form-control" id="OdPrisma" :readonly="TpLenteSelect.Prisma == 'NO'"/>
																<center><label id="lblodprisma">0 - 15</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdPrisma" target="OdPrisma" placement="top"> Rango unicamente de 0 a 15</b-tooltip>
															</div>

															<!-- POSICION -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-2">
																<label class="form-label" for="OdPosicion">Posición</label>
																<select v-model="objPedido.OdPosicion" class="form-control-search form-select" id="OdPosicion" :disabled="TpLenteSelect.Posicion == 'NO'">
																	<option value="">Seleccione una opción</option>
																	<option v-for="(item, index) in ListPosicionesLentes" :key="index" :value="item.id">{{item.label}}</option>
																</select>
																<CValidation v-if="this.errorvalidacion.OdPosicion" :Mensaje="'*'+errorvalidacion.OdPosicion[0]"/>
															</div>
														</div>
													
													
														<!---- OJO LADO IZQUIERDO ---->
														<div class="row mt-4">
															<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
																<div class="form-check form-switch">
																	<input v-model="objPedido.OjoIzquierdo" @change="limpiaRXIzquierdo()" class="form-check-input" type="checkbox" role="switch" id="OjoIzquierdo">
																	<label class="form-check-label" for="OjoIzquierdo">RX Ojo Izquierdo</label>
																</div>
															</div>
														</div>


														<div v-if="objPedido.OjoIzquierdo" class="row mt-1">
															<!-- ESFERA IZQUIERDA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OiEsfera">Esfera</label>
																<input type="text" v-model="objPedido.OiEsfera" 
																	@keyup.enter="validaRangosRX('Esfera','OiEsfera')" 
																	@blur="validaRangosRX('Esfera','OiEsfera')" 
																	@input="$numberosPermitidos($event,objPedido,'OiEsfera'); accionInput('OiEsfera','Esfera');"
																	:style="EsferaIzquierda.showTool ? 'border-color:red;' :''"
																	class="form-control" id="OiEsfera"/>

																<b-tooltip id="tooltip_OiEsfera" :show.sync="EsferaIzquierda.showTool" target="OiEsfera" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

																<b-popover id="popover_OiEsfera" :disabled="true" custom-class="IzEsferas" :show.sync="EsferaIzquierda.showPopOver" target="OiEsfera" ref="popOiEsfera" placement="top" @hidden="onHidden()">
																	<template #title>
																		<b-button @click="onClose('OiEsfera','Esfera')" class="close c-pop" aria-label="Close">
																			<i class="fas fa-times text-black"></i>
																		</b-button>
																		Selecciona una Graduación
																	</template>

																	<span >
																		<div class="row" id="OiEsferaPopContener">
																			<div v-for="(item4,index4) in EsferaIzquierda.listaMedidas" :key="index4+'_OiEf'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																				<button @click="getCheckValores('Esfera','OiEsfera',item4.Valor)" type="button" class="btn btn-primary" :id="index4+'_btnOiEf'"
																				style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item4.Valor }}</button>
																			</div>	
																		</div>
																	</span>

																</b-popover>
															</div>

															<!-- CILINDRO IZQUIERDO -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OiCilindro">Cilindro</label>
																<input type="text" v-model="objPedido.OiCilindro" 
																@keyup.enter="validaRangosRX('Cilindro','OiCilindro')" 
																@blur="validaRangosRX('Cilindro','OiCilindro')" 
																	@input="$numberosPermitidos($event,objPedido,'OiCilindro'); accionInput('OiCilindro','Cilindro');"
																	:style="CilindroIzquierdo.showTool ? 'border-color:red;' :''" 
																	class="form-control" id="OiCilindro"/>
																
																<b-tooltip id="tooltip_OiCilindro" :show.sync="CilindroIzquierdo.showTool" target="OiCilindro" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

																<b-popover :disabled="true"  :show.sync="CilindroIzquierdo.showPopOver" target="OiCilindro" ref="popOiCilindro" placement="top" @hidden="onHidden()">
																	<template #title>
																		<b-button @click="onClose('OiCilindro','Cilindro')" class="close c-pop" aria-label="Close">
																			<i class="fas fa-times text-black"></i>
																		</b-button>
																		Selecciona una Graduación
																	</template>

																	<span >
																		<div class="row" id="OiCilindroPopContener">
																			<div v-for="(item5,index) in CilindroIzquierdo.listaMedidas" :key="index+'_OiCl'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																				<button  @click="getCheckValores('Cilindro','OiCilindro',item5.Valor)"  type="button" class="btn btn-primary" 
																					style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item5.Valor }}</button>
																			</div>	
																		</div>
																	</span>

																</b-popover> 
															</div>

															<!-- EJE -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OiEje">Eje</label>
																<input @input="$onlyNums($event,objPedido,'OiEje'), validaRangosRX('Eje','OiEje')" type="text" v-model="objPedido.OiEje" class="form-control" id="OiEje"
																:style="toolTipRX.showToolOiEje || toolTipRX.showToolOiEjeRequire ? 'border-color:red;' :''" 
																:readonly="CilindroIzquierdo.blockEje" />
																<center><label id="lblodeje">0 - 180</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiEje" target="OiEje" placement="top"> Rango unicamente de 0 a 180</b-tooltip>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiEjeRequire" target="OiEje" placement="top"> Campo Obligatorio</b-tooltip>
															</div>

															<!-- RANGO ADICIONAL IZQUIERDA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="Adicion">*Adición</label>
																<input type="text" v-model="objPedido.OiAdicion" 
																	@keyup.enter="validaRangosRX('RangoAdicional','OiAdicion')"
																	@blur="validaRangosRX('RangoAdicional','OiAdicion')"
																	@input="$numberosPermitidos($event,objPedido,'OiAdicion'); accionInput('OiAdicion','RangoAdicional');"
																	:style="toolTipRX.showTool ? 'border-color:red;' :''"
																	class="form-control" id="OiAdicion" :readonly="TpLenteSelect.Adicion == 'NO'"/>

																<b-tooltip id="tooltip_OiAdicion" :show.sync="RanAdicionalIzquierdo.showTool" target="OiAdicion" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

																<b-popover id="popover_OiAdicion"  :disabled="true"  :show.sync="RanAdicionalIzquierdo.showPopOver" target="OiAdicion" ref="popOiAdicion" placement="top" @hidden="onHidden()">
																	<template #title>
																		<b-button @click="onClose('OiAdicion','RangoAdicional')" class="close c-pop" aria-label="Close">
																			<i class="fas fa-times text-black"></i>
																		</b-button>
																		Selecciona una Graduación
																	</template>

																	<span >
																		<div class="row" id="OiAdicionPopContener">
																			<div v-for="(item6,index6) in RanAdicionalIzquierdo.listaMedidas" :key="index6+'_OiRg'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																				<button @click="getCheckValores('RangoAdicional','OiAdicion',item6.Valor)"  type="button" class="btn btn-primary" :id="index6+'_btnOiRg'"
																				style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item6.Valor }}</button>
																			</div>	
																		</div>
																	</span>

																</b-popover>

															</div>

															<!-- ALTO DE MONTURA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OiAltMon">*Alt. Mon</label>
																<input @input="$onlyNums($event,objPedido,'OiAltMon')" @change="validaRangosRX('AltMont','OiAltMon')" :style="toolTipRX.showToolOiAltMon ? 'border-color:red;' :''" type="text" v-model="objPedido.OiAltMon" 
																class="form-control" id="OiAltMon" :readonly="TpLenteSelect.AltMon == 'NO'" />

																<center><label id="lblodaltmon">{{TpLenteSelect.ValMinMon}} - {{ TpLenteSelect.ValMaxMon }}</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiAltMon" target="OiAltMon" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinMon}} a {{ TpLenteSelect.ValMaxMon }}</b-tooltip>
															</div>

															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OiAltSeg">Alt. Seg.</label>
																<input @input="$onlyNums($event,objPedido,'OiAltSeg')" @change="validaRangosRX('AltSeg','OiAltSeg')" :style="toolTipRX.showToolOiAltSeg ? 'border-color:red;' :''" type="text" v-model="objPedido.OiAltSeg" 
																	class="form-control" id="OiAltSeg" :readonly="TpLenteSelect.AltSeg == 'NO'" />

																<center><label id="lblodaltseg">{{TpLenteSelect.ValMinSeg}} - {{ TpLenteSelect.ValMaxSeg }}</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiAltSeg" target="OiAltSeg" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinSeg}} a {{ TpLenteSelect.ValMaxSeg }}</b-tooltip>
															</div>
															
															<!-- DNP -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OiDnp">*DNP</label>
																<input @input="$onlyNums($event,objPedido,'OiDnp')" @change="validaRangosRX('Dnp','OiDnp')" :style="toolTipRX.showToolOiDnp ? 'border-color:red;' :''" type="text" v-model="objPedido.OiDnp" 
																class="form-control" id="OiDnp" />

																<center><label id="lbloddnp">20 - 50</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiDnp" target="OiDnp" placement="top"> Rango unicamente de 20 a 50</b-tooltip>
															</div>

															<!-- PRISMA -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
																<label class="form-label" for="OiPrisma">Prisma</label>
																<input @input="$onlyNums($event,objPedido,'OiPrisma'), validaRangosRX('Prisma','OiPrisma')" :style="toolTipRX.showToolOiPrisma ? 'border-color:red;' :''" type="text" v-model="objPedido.OiPrisma" 
																class="form-control" id="OiPrisma" :readonly="TpLenteSelect.Prisma == 'NO'" />

																<center><label id="lblodprisma">0 - 15</label></center>
																<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiPrisma" target="OiPrisma" placement="top"> Rango unicamente de 0 a 15</b-tooltip>
															</div>

															<!-- POSICION -->
															<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-2">
																<label class="form-label" for="OdPosicion">Posición</label>
																<select v-model="objPedido.OiPosicion" class="form-control-search form-select" id="OdPosicion" :disabled="TpLenteSelect.Posicion == 'NO'">
																	<option value="">Seleccione una opción</option>
																	<option v-for="(item, index) in ListPosicionesLentes" :key="index" :value="item.id">{{item.label}}</option>
																</select>
																<CValidation v-if="this.errorvalidacion.OdPosicion" :Mensaje="'*'+errorvalidacion.OdPosicion[0]"/>
															</div>
														</div>
													</template>
													<!---- TERMINA CONFIGRACION DE VALORES PARA LENTES RX ---->


													<!-- ******************** TERMINA BLOQUE FUNCIONAL SOLO PARA PROCESO #1 ******************** -->


													<!-- ************************ BLOQUE FUNCIONAL SOLO PARA PROCESO #2 ************************ -->
													<!-- SELECTOR DE NUMERO DE PARES -->
													<div v-if="procesoActivo == 2" class="row mt-4">

														<h6>Cantidad de Par de Lentes</h6>
														<div class="col-auto">
															<div class=" form-check-inline form-check form-switch form-sw">
																<input v-model="objPedido.NumPar" class="form-check-input" type="radio" role="switch" :value="1" id="NumPar1" >
																<label class="form-check-label" for="flexSwitchCheckDefault">Un Par (1)</label>
															</div>
														</div>
														<div class="col-auto">
															<div class=" form-check-inline form-check form-switch form-sw">
																<input v-model="objPedido.NumPar" class="form-check-input" type="radio" role="switch" :value="2" id="NumPar2" >
																<label class="form-check-label" for="flexSwitchCheckDefault">Mas de un Par (2 o más)</label>
															</div>
														</div>
														<CValidation v-if="this.errorvalidacion.NumPar" :Mensaje="'*'+errorvalidacion.NumPar[0]"/>

													</div>
													<!-- ******************** TERMINA BLOQUE FUNCIONAL SOLO PARA PROCESO #2 ******************** -->


													<div v-show="parseInt(objPedido.IdTipoLente) > 0" class="row mt-4">
														<div class="col-12 text-end">
															<button @click="cambiarPaso(2)" type="button" class="btn btn-primary">Siguiente</button>
														</div>
													</div>

												</div>
												<!-- END PASO 1 -->
												
												<!-- PASO 2 -->
												<div v-if="showPasos.paso2">
													<h5 class="card-title">Configuración de Lente</h5>

													<!-- ************************ BLOQUE FUNCIONAL SOLO PARA PROCESO #1 ************************ -->
													<template v-if="procesoActivo == 1">

														<!-- SELECTOR DE SUB-LINEA-->
														<div v-if="parseInt(TpLenteSelect.IdTipoLente) == 1" class="row mt-2">
															<h6>* Sub-línea</h6>
															
															<div class="col-12 col-sm-2 col-md-4 col-lg-3" v-for="(item3,idexsublinea2) in ListaSublineas" :key="idexsublinea2">
																<div class=" form-check-inline form-check form-switch form-sw">
																	<input v-model="objPedido.IdSubLinea" @change="getArticulosWeb()" class="form-check-input" type="radio" role="switch" :value="item3.IdSublinea" :id="'idswitchplente'+item3.IdSublinea" >
																	<label class="form-check-label" for="flexSwitchCheckDefault">{{ item3.Nombre }}</label>
																</div>
															</div>
															
															<CValidation v-if="this.errorvalidacion.IdSubLinea" :Mensaje="'*'+errorvalidacion.IdSubLinea[0]"/>
														</div>

														<!-- SELECTOR DE ARTICULO "WEB" -->
														<span id="articulosrx"></span>
														<div class="row mt-4" v-show="showArticulos" >
															<h6><span class="text-red">*</span> Artículos</h6>
															<div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" v-for="(item4,idexarticuloweb) in ListaArticulosWeb" :key="idexarticuloweb">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item4.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdArticuloWeb" @change="viewLentesOrMateriales()" :disabled="item4.Seleccionable=='NO'"  class="form-check-input" 
																	type="radio" role="switch" :value="item4.IdArticuloWeb" :id="'idswitcharticulo'+item4.IdArticuloWeb" >
																	<label class="form-check-label"  for="idswitcharticulo">{{ item4.Nombre }}</label>
																</div>
															</div>
																		
															<CValidation v-if="this.errorvalidacion.IdArticuloWeb" :Mensaje="'*'+errorvalidacion.IdArticuloWeb[0]"/>
														</div>

														<!-- PARAMETROS DE PERSONALIZACION DIGITAL -->
														<span id="ParamPersonalizacion"></span>
														<div v-if="TpLenteSelect.AltSeg == 'SI' || articuloWebSelect.AnguloPantoscopico == 'SI' || articuloWebSelect.AnguloPanoramico == 'SI' 
																	|| articuloWebSelect.DistanciaVertice == 'SI' || articuloWebSelect.DistanciaLectura == 'SI' || articuloWebSelect.Iniciales == 'SI'" class="row mt-4">
															
															<h6 class="mt-2">Parametros de Personalización Digital</h6>

															<!-- ALTURA DE SEGMENTO -->
															<div v-if="TpLenteSelect.AltSeg == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="ReqAltSeg"><span class="text-danger">*</span> Alto Segmento <i class="fas fa-info-circle fa-lg text-info" style="cursor: pointer;" id="consejo-AltSegmento" ></i></label>
																<b-popover custom-class="IzEsferas" target="consejo-AltSegmento" triggers="hover" placement="top">
																	<template #title>Altura de segmento en un lente free-form</template>
																	Es la distancia vertical desde el centro óptico del lente hasta el borde inferior del armazón, donde inicia la zona de visión cercana. 
																	<br>Es clave para personalizar la posición de la adición progresiva, garantizando una transición suave entre distancias y mayor comodidad visual.
																</b-popover>

																<input @input="$onlyNums($event,objPedido,'AlturaSegmento');" @change="validaRangosRX('AltSegmento');" type="text" v-model="objPedido.AlturaSegmento" class="form-control mb-2" id="AlturaSegmento"  />
																<CValidation v-if="this.errorvalidacion.AlturaSegmento" :Mensaje="'*'+errorvalidacion.AlturaSegmento[0]"/>

																<b-tooltip :disabled="true" id="tooltip_AlturaSegmento" :show.sync="toolTipRX.showToolAltSegSecundario" target="AlturaSegmento" placement="top"> Introduce un valor mayor a 0  </b-tooltip>
															</div>

															<!-- ANGULO PANTOSCOPICO -->
															<div v-if="articuloWebSelect.AnguloPantoscopico == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="AnguloPantoscopico"><span class="text-danger">*</span> Ang. pantoscópico</label>
																<input @input="$onlyNums($event,objPedido,'AnguloPantoscopico'); validaRangosRX('AngPantos');" type="text" v-model="objPedido.AnguloPantoscopico" class="form-control" id="AnguloPantoscopico"  />
																<center><label id="lblAnguloPantoscopico">0° a 20°</label></center>
																<CValidation v-if="this.errorvalidacion.AnguloPantoscopico" :Mensaje="'*'+errorvalidacion.AnguloPantoscopico[0]"/>

																<b-tooltip :disabled="true" id="tooltip_AnguloPantoscopico" :show.sync="toolTipRX.showToolAngPantos" target="AnguloPantoscopico" placement="top"> Introduce un valor entre 0° y 20° </b-tooltip>
															</div>

															<!-- ANGULO PANORAMICO -->
															<div v-if="articuloWebSelect.AnguloPanoramico == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="AnguloPanoramico"><span class="text-danger">*</span> Ang. panorámico</label>
																<input @input="$onlyNums($event,objPedido,'AnguloPanoramico'); validaRangosRX('AngPanoram');" type="text" v-model="objPedido.AnguloPanoramico" class="form-control" id="AnguloPanoramico"  />
																<center><label id="lblAnguloPanoramico">0° a 20°</label></center>
																<CValidation v-if="this.errorvalidacion.AnguloPanoramico" :Mensaje="'*'+errorvalidacion.AnguloPanoramico[0]"/>

																<b-tooltip :disabled="true" id="tooltip_AnguloPanoramico" :show.sync="toolTipRX.showToolAngPanoram" target="AnguloPanoramico" placement="top"> Introduce un valor entre 0° y 20° </b-tooltip>
															</div>

															<!-- DISTANCIA DEL VERTICE -->
															<div v-if="articuloWebSelect.DistanciaVertice == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="DistanciaVertice"><span class="text-danger">*</span> Dist. al vertice (mm)</label>
																<input @input="$onlyNums($event,objPedido,'DistanciaVertice'); validaRangosRX('DistVertice');" type="text" v-model="objPedido.DistanciaVertice" class="form-control" id="DistanciaVertice"  />
																<center><label id="lblDistanciaVertice">0 a 40 mm</label></center>
																<CValidation v-if="this.errorvalidacion.DistanciaVertice" :Mensaje="'*'+errorvalidacion.DistanciaVertice[0]"/>

																<b-tooltip :disabled="true" id="tooltip_DistanciaVertice" :show.sync="toolTipRX.showToolDistVertice" target="DistanciaVertice" placement="top"> Introduce un valor entre 0 y 40 </b-tooltip>
															</div>

															<!-- DISTANCIA DE LECTURA -->
															<div v-if="articuloWebSelect.DistanciaLectura == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="DistanciaLectura"><span class="text-danger">*</span> Dist. de lectura (cm)</label>
																<input @input="$onlyNums($event,objPedido,'DistanciaLectura'); validaRangosRX('DistLectura');" type="text" v-model="objPedido.DistanciaLectura" class="form-control" id="DistanciaLectura"  />
																<center><label id="lblDistanciaLectura">0 a 40 cm</label></center>
																<CValidation v-if="this.errorvalidacion.DistanciaLectura" :Mensaje="'*'+errorvalidacion.DistanciaLectura[0]"/>

																<b-tooltip :disabled="true" id="tooltip_DistanciaLectura" :show.sync="toolTipRX.showToolDistLectura" target="DistanciaLectura" placement="top"> Introduce un valor entre 0 y 40 </b-tooltip>
															</div>

															<!-- INICIALES -->
															<div v-if="articuloWebSelect.Iniciales == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="Iniciales"><span class="text-danger">*</span> Iniciales</label>
																<input type="text" v-model="objPedido.Iniciales" class="form-control" id="Iniciales"  />
																<CValidation v-if="this.errorvalidacion.Iniciales" :Mensaje="'*'+errorvalidacion.Iniciales[0]"/>
															</div>

														</div>

														<!-- SELECTOR DE MATERIALES -->
														<span id="materialesrx"></span>
														<div v-show="parseInt(objPedido.IdArticuloWeb) > 0" class="row mt-4">
															<h6>* Materiales</h6>
															<div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" v-for="(item5,idexmateriales) in ListaMateriales" :key="idexmateriales">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item5.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdMaterial" @change="getValidMaterialSelected()" :disabled="item5.Seleccionable=='NO'"  class="form-check-input" 
																	type="radio" role="switch" :value="item5.IdMaterial" :id="'idswitchmaterial'+item5.IdMaterial" >
																	<label class="form-check-label"  for="idswitchmaterial">{{ item5.Nombre }}</label>
																</div>
															</div>
																	
															<CValidation v-if="this.errorvalidacion.IdMaterial" :Mensaje="'*'+errorvalidacion.IdMaterial[0]"/>

														</div>

														<!-- SELECTOR DE PROTECCIONES -->
														<span id="proteccionesrx"></span>
														<div v-if="!bndBloqueoProtxRecub && showProteccion && parseInt(objPedido.IdMaterial) > 0" class="row mt-4">
															<h6>* Protección</h6>
															<div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" v-for="(item6,idexprotecc) in ListaProtecciones" :key="idexprotecc">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item6.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdProteccion" @change="calculaCostosProtecciones()" :disabled="item6.Seleccionable=='NO'"  class="form-check-input" 
																	type="radio" role="switch" :value="item6.IdProteccion" :id="'idswitchprotecc'+item6.IdProteccion" >
																	<label class="form-check-label"  for="idswitchprotecc">{{ item6.Nombre }}</label>
																</div>
															</div>
															<CValidation v-if="this.errorvalidacion.IdProteccion" :Mensaje="'*'+errorvalidacion.IdProteccion[0]"/>
														</div>

														<!-- SELECTOR DE RECUBRIMIENTO -->
														<span id="recubrimientorx"></span>
														<div v-if="!bndBloqueoProtxRecub && showRecubrimiento && parseInt(objPedido.IdProteccion) > 0" class="row mt-4">
															<h6>* Recubrimiento</h6>
															<div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" v-for="(item7,idexrecubrimiento) in ListaRecubrimientos" :key="idexrecubrimiento">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item7.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdRecubrimiento" @change="calculaCostosRecubrimiento()" :disabled="item7.Seleccionable=='NO'"  class="form-check-input" 
																	type="radio" role="switch" :value="item7.IdRecubrimiento" :id="'idswitchrecubrimiento'+item7.IdRecubrimiento" >
																	<label class="form-check-label"  for="idswitchrecubrimiento">{{ item7.Nombre }}</label>
																</div>
															</div>

															<CValidation v-if="this.errorvalidacion.IdRecubrimiento" :Mensaje="'*'+errorvalidacion.IdRecubrimiento[0]"/>
														</div>
														
													</template>
													<!-- ******************** TERMINA BLOQUE FUNCIONAL SOLO PARA PROCESO #1 ******************** -->

														
													<!-- ************************ BLOQUE FUNCIONAL SOLO PARA PROCESO #2 ************************ -->
													<template v-if="procesoActivo == 2">

														<!-- *************** BLOQUE DE SOLO UN PAR DE LENTES *************** -->

														<div v-if="objPedido.NumPar == 1">
															
															<!-- SELECTOR DE ARTICULO "WEB" -->
															<div class="row mt-4" v-show="showArticulos" >
																<h6><b class="text-danger">*</b>Artículos</h6>
																<div class="col-12 col-md-4 col-lg-3 col-xl-3" v-for="(item4,idexarticuloweb) in ListaArticulosWeb" :key="idexarticuloweb">
																	<div class=" form-check-inline form-check form-switch form-sw" :title="item4.RazonBloqueo" v-b-tooltip.hover>
																		<input v-model="objPedido.IdArticuloWeb" @change="viewLentesOrMateriales()" :disabled="item4.Seleccionable=='NO'"  class="form-check-input" 
																		type="radio" role="switch" :value="item4.IdArticuloWeb" :id="'idswitcharticulo'+item4.IdArticuloWeb" >
																		<label class="form-check-label"  for="idswitcharticulo">{{ item4.Nombre }}</label>
																	</div>
																</div>
																			
																<CValidation v-if="this.errorvalidacion.IdArticuloWeb" :Mensaje="'*'+errorvalidacion.IdArticuloWeb[0]"/>
															</div>

															<!-- GRADUACIONES PARA OJO DERECHO -->
															<div v-if="parseInt(objPedido.NumPar) == 1 && showTablaConfigLentes" class="row mt-4">
																<h6 class="mt-2">Medidas RX</h6>
																<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
																	<div class="form-check form-switch">
																		<input v-model="objPedido.OjoDerecho" @change="limpiaRXDerecho(2, true)" class="form-check-input" type="checkbox" role="switch" id="OjoDerechoLT">
																		<label class="form-check-label" for="OjoDerechoLT">RX Ojo Derecho</label>
																	</div>
																</div>
															</div>

															<div v-if="objPedido.OjoDerecho" class="row mt-1">
																
																<!-- ESFERA DERECHA -->
																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
																	<label class="form-label" for="OdEsferaLT"><b class="text-danger">*</b> Esfera</label>
																	<select v-model="objPedido.OdEsfera" @change="getEsferaxCilindros('DER')" class="form-control-search form-select" id="OdEsferaLT">
																		<option value="">Seleccione una opción</option>
																		<option v-for="(item, index) in ListaEsferasSelect" :key="index" :value="item.RangoEsfera">{{item.RangoEsfera}}</option>
																	</select>

																</div>

																<!-- CILINDRO DERECHO -->
																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">

																	<label class="form-label" for="OdCilindroLT"><b class="text-danger">*</b> Cilindro</label>
																	<select v-model="objPedido.OdCilindro" @change="desblockBtnLT(1)" class="form-control-search form-select" id="OdCilindroLT" :disabled="ListaCilindrosSelect.Derecho.length == 0">
																		<option value="">Seleccione una opción</option>
																		<option v-for="(item, index) in ListaCilindrosSelect.Derecho" :key="index" :value="item.RangoCilindro">{{item.RangoCilindro}}</option>
																	</select>
																	
																</div>

																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
																	<label class="form-label" for="OdEje"><b class="text-danger">*</b> Eje</label>
																	<input @input="$onlyNums($event,objPedido,'OdEje'), validaRangosRX('Eje','OdEje'), desblockBtnLT()" type="text" v-model="objPedido.OdEje" class="form-control" id="OdEje"
																	:style="toolTipRX.showToolOdEje || toolTipRX.showToolOdEjeRequire ? 'border-color:red;' :''" />

																	<center><label id="lblodeje">0 - 180</label></center>
																	<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdEje" target="OdEje" placement="top"> Rango unicamente de 0 a 180</b-tooltip>
																	<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdEjeRequire" target="OdEje" placement="top"> Campo Obligatorio</b-tooltip>
																</div>

																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
																	<label class="form-label" for="OdDnp">DNP</label>
																	<input @input="$onlyNums($event,objPedido,'OdDnp')" @change="validaRangosRX('Dnp','OdDnp')" type="text" v-model="objPedido.OdDnp" :style="toolTipRX.showToolOdDnp ? 'border-color:red;' :''" 
																		class="form-control" id="OdDnp" />
																	<center><label id="lbloddnp">20 - 50</label></center>
																	<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdDnp" target="OdDnp" placement="top"> Rango unicamente de 20 a 50</b-tooltip>
																</div>
																
															</div>
															
															<!-- GRADUACIONES PARA OJO IZQUIERDO -->
															<div v-if="parseInt(objPedido.NumPar) == 1 && showTablaConfigLentes" class="row mt-4 mb-4">
																<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
																	<div class="form-check form-switch">
																		<input v-model="objPedido.OjoIzquierdo" @change="limpiaRXIzquierdo(2, true)" class="form-check-input" type="checkbox" role="switch" id="OjoIzquierdoLT">
																		<label class="form-check-label" for="OjoIzquierdoLT">RX Ojo Izquierdo</label>
																	</div>
																</div>
															</div>

															<div v-if=" objPedido.OjoIzquierdo" class="row mt-1">

																<!-- ESFERA IZQUIERDA -->
																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">

																	<label class="form-label" for="OiEsferaLT"><b class="text-danger">*</b> Esfera</label>
																	<select v-model="objPedido.OiEsfera" @change="getEsferaxCilindros('IZQ')" class="form-control-search form-select" id="OiEsferaLT">
																		<option value="">Seleccione una opción</option>
																		<option v-for="(item, index) in ListaEsferasSelect" :key="index" :value="item.RangoEsfera">{{item.RangoEsfera}}</option>
																	</select>
																
																</div>

																<!-- CILINDRO IZQUIERDO -->
																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">

																	<label class="form-label" for="OiCilindroLT"><b class="text-danger">*</b> Cilindro</label>
																	<select v-model="objPedido.OiCilindro" @change="desblockBtnLT(1)" class="form-control-search form-select" id="OiCilindroLT" :disabled="ListaCilindrosSelect.Izquierdo.length == 0">
																		<option value="">Seleccione una opción</option>
																		<option v-for="(item, index) in ListaCilindrosSelect.Izquierdo" :key="index" :value="item.RangoCilindro">{{item.RangoCilindro}}</option>
																	</select>

																</div>

																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
																	<label class="form-label" for="OiEje"><b class="text-danger">*</b> Eje</label>
																	<input @input="$onlyNums($event,objPedido,'OiEje'), validaRangosRX('Eje','OiEje'), desblockBtnLT()" type="text" v-model="objPedido.OiEje" class="form-control" id="OiEje"
																	:style="toolTipRX.showToolOiEje || toolTipRX.showToolOiEjeRequire ? 'border-color:red;' :''" />

																	<center><label id="lblodeje">0 - 180</label></center>
																	<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiEje" target="OiEje" placement="top"> Rango unicamente de 0 a 180</b-tooltip>
																	<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiEjeRequire" target="OiEje" placement="top"> Campo Obligatorio</b-tooltip>
																</div>

																<div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
																	<label class="form-label" for="OiDnp">DNP</label>
																	<input @input="$onlyNums($event,objPedido,'OiDnp')" @change="validaRangosRX('Dnp','OiDnp')" :style="toolTipRX.showToolOiDnp ? 'border-color:red;' :''" type="text" v-model="objPedido.OiDnp" 
																	class="form-control" id="OiDnp" />

																	<center><label id="lbloddnp">20 - 50</label></center>
																	<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiDnp" target="OiDnp" placement="top"> Rango unicamente de 20 a 50</b-tooltip>
																</div>

															</div>

															<!-- BOTON DE CALCULO -->
															<div v-if="objPedido.OjoDerecho || objPedido.OjoIzquierdo" class="row">
																<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3">
																	<div class="d-grid gap-2 col-12 col-sm-12 col-md-12 col-lg-6 mx-auto">
																		<button class="btn btn-warning" type="button" @click="calculaCostosLenteTerminado()" :disabled="blockBtnCalculaLT">Calcular</button>
																	</div>
																</div> 
															</div>

														</div>
														<!-- *********** TERMINA BLOQUE DE SOLO UN PAR DE LENTES *********** -->


														<!-- ******** BLOQUE FUNCIONAL PARA MAS DE UN PAR DE LENTES ******** -->
														<div v-if="objPedido.NumPar == 2">

															<div v-if="bndBloqueoArticulo">
																<h6>
																	<i class="fad fa-info-circle fa-lg" id="razon-bloqueo-articulo" style="--fa-primary-color: #000000; --fa-secondary-color: #f5dc3d; --fa-secondary-opacity: 1; cursor: pointer; margin-top:2.75rem;"></i>
																</h6>
																<b-popover :show.sync="toolTipRX.showPopArticulo" target="razon-bloqueo-articulo" triggers="hover" placement="top">
																	<template #title>Articulo no disponible</template>
																	{{ articuloWebSelect.RazonBloqueo }}
																</b-popover>
															</div>

															<div class="row">
																<div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
																	<label class="form-label" for="IdArticuloWeb"><b class="text-danger">*</b> Artículos</label>
																	<select v-model="objPedido.IdArticuloWeb" @change="viewLentesOrMateriales()" class="form-control-search form-select" id="IdArticuloWeb">
																		<option :value="0">Seleccione una opción</option>
																		<option v-for="(item, index) in ListaArticulosWeb" :key="index" :value="item.IdArticuloWeb">{{item.Nombre}}</option>
																	</select>
																	<CValidation v-if="this.errorvalidacion.IdArticuloWeb" :Mensaje="'*'+errorvalidacion.IdArticuloWeb[0]"/>
																</div>

															
																<!-- ESFERA -->
																<div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">

																	<label class="form-label" for="OiEsferaLT"><b class="text-danger">*</b> Esfera</label>
																	<select v-model="objTblLenteTerminado.ValEsfera" @change="getEsferaxCilindros('MULT',false,false);desblockBtnMLT();" class="form-control-search form-select" id="OiEsferaLT" :disabled="bndBlockInputsConfig">
																		<option value="">Seleccione una opción</option>
																		<option v-for="(item, index) in ListaEsferasSelect" :key="index" :value="item.RangoEsfera">{{item.RangoEsfera}}</option>
																	</select>

																</div>

																<!-- CILINDRO -->
																<div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">

																	<label class="form-label" for="OiCilindroLT"><b class="text-danger">*</b> Cilindro</label>
																	<select v-model="objTblLenteTerminado.ValCilindro" @change="desblockBtnMLT()" class="form-control-search form-select" id="OiCilindroLT" :disabled="bndBlockInputsConfig">
																		<option value="">Seleccione una opción</option>
																		<option v-for="(item, index) in ListaCilindrosSelect.Multiple" :key="index" :value="item.RangoCilindro">{{item.RangoCilindro}}</option>
																	</select>

																</div>

																<!-- CANTIDAD -->
																<div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
																	<label class="form-label" for="CantidadLT"><b class="text-danger">*</b> Cantidad</label>
																	<input @input="$onlyNums($event,objTblLenteTerminado,'Cantidad'); desblockBtnMLT();" type="text" v-model="objTblLenteTerminado.Cantidad" class="form-control" id="CantidadLT" :disabled="bndBlockInputsConfig"/>
																</div>


																<!-- BOTON -->
																<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
																	<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																	<div class="d-grid gap-2 col-12 mx-auto">
																		<button :disabled="bndBlockLenteT" type="button" class="btn btn-warning" @click="agregarMultLentes()">
																			<i class="fa fa-plus-circle"></i> Agregar
																		</button>
																	</div>
																	
																</div>
															</div>


															<div class="row mt-1">
																<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
																	<div class="table-responsive">
																		<table class="table">
																			<thead>
																				<th>Articulo</th>
																				<th>Esfera</th>
																				<th>Cilindro</th>
																				<th>Cantidad</th>
																				<th>Eliminar</th>
																			</thead>
																			<tbody>
																				<tr v-for="(itemtbl,indxtbl) in listaDetalleLT"  :key="indxtbl">
																					<td>{{ itemtbl.Descripcion }}</td>
																					<td>{{ itemtbl.ValEsfera }}</td>
																					<td>{{ itemtbl.ValCilindro }}</td>
																					<td>{{ itemtbl.Cantidad }}</td>
																					<td>
																						<a class="btn btn-link text-warning px-3 mb-0 mr-1" @click="eliminarMulLentes(indxtbl,itemtbl.IdArticuloWeb)">
																							<i class="fa fa-trash"></i> Eliminar
																						</a>
																					</td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																
															</div>

															<div class="row mt-2">
																<div class="col-12">
																	<label class="form-label" for="ObservacionesGeneral">Observaciones Generales</label>
																	<textarea v-model="objPedido.ObservacionesGeneral" class="form-control" rows="2"></textarea>
																</div>
															</div>
														</div>
														<!-- **** TERMINA BLOQUE FUNCIONAL PARA MAS DE UN PAR DE LENTES **** -->
														
													</template>
													<!-- ******************** TERMINA BLOQUE FUNCIONAL SOLO PARA PROCESO #2 ******************** -->
													
													<!-- ************************ BLOQUE FUNCIONAL SOLO PARA PROCESO #3 ************************ -->
													<template v-if="procesoActivo == 3">

														<!-- SELECTOR DE ARTICULO "WEB" -->
														<!--<div class="row mt-4" v-show="showArticulos" >
															<h6><b class="text-danger">*</b>Artículos</h6>
															<div class="col-3" v-for="(item4,idexarticuloweb) in ListaArticulosWeb" :key="idexarticuloweb">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item4.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdArticuloWeb" @change="viewLentesOrMateriales()" :disabled="item4.Seleccionable=='NO'"  class="form-check-input" 
																	type="radio" role="switch" :value="item4.IdArticuloWeb" :id="'idswitcharticulo'+item4.IdArticuloWeb" >
																	<label class="form-check-label"  for="idswitcharticulo">{{ item4.Nombre }}</label>
																</div>
															</div>
																		
															<CValidation v-if="this.errorvalidacion.IdArticuloWeb" :Mensaje="'*'+errorvalidacion.IdArticuloWeb[0]"/>
														</div>

														<div v-if="bndBloqueoArticulo">
															<h6>
																<i class="fad fa-info-circle fa-lg" id="razon-bloqueo-articulo" style="--fa-primary-color: #000000; --fa-secondary-color: #f5dc3d; --fa-secondary-opacity: 1; cursor: pointer; margin-top:2.75rem;"></i>
															</h6>
															<b-popover :show.sync="toolTipRX.showPopArticulo" target="razon-bloqueo-articulo" triggers="hover" placement="top">
																<template #title>Articulo no disponible</template>
																{{ articuloWebSelect.RazonBloqueo }}
															</b-popover>
														</div> -->

														<div class="row">
															<div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
																<h6><b class="text-danger">*</b> Artículos</h6>
																<select v-model="objPedido.IdArticuloWeb" @change="viewLentesOrMateriales()" class="form-control-search form-select" id="IdArticuloWeb">
																	<option :value="0">Seleccione una opción</option>
																	<option v-for="(item, index) in ListaArticulosWeb" :key="index" :value="item.IdArticuloWeb">{{item.Nombre}}</option>
																</select>
																<CValidation v-if="this.errorvalidacion.IdArticuloWeb" :Mensaje="'*'+errorvalidacion.IdArticuloWeb[0]"/>
															</div>
														</div>

														<div v-if="bndLentCUseColors" class="row mt-3">
															<h6 class="card-title"><b class="text-danger">*</b>Color</h6>
															<div class="col-6 col-md-4 col-lg-3 col-xl-2"  v-for="(item8,idexcolorlc) in ListaColoresLenteC" :key="idexcolorlc">
																<div  class="form-check form-check-inline mb-2">
																	<input v-model="objTblLenteContacto.IdColor" @change="setColorLentC(item8)" :style="'background-color:'+item8.Color+';'" :id="'LcRadioColor'+item8.IdColor" :value="item8.IdColor" 
																	:title="item8.Nombre" v-b-tooltip.hover class="form-check-input lente" type="radio" name="inlineRadioOptions" >
																	<label class="form-check-label" :for="'LCRadioColor'+item8.IdColor">{{ item8.Nombre }}</label>
																</div>
															</div>
															
														</div>

														<div v-if="objPedido.IdArticuloWeb > 0 && bndBlockLenteC == false" class="row mt-4">
															<!-- ESFERA -->
															<div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 mb-2">

																<label class="form-label" for="LenteCEsfera"><b class="text-danger">*</b> Esfera</label>
																<select v-model="objTblLenteContacto.Esfera" @change="getEsferaxCilindros('MULTLC',false,false)" :disabled="blockEsfera" class="form-control-search form-select" id="LenteCEsfera">
																	<option value="">Seleccione una opción</option>
																	<option v-for="(item, index) in ListaEsferasSelect" :key="index" :value="item.RangoEsfera">{{item.RangoEsfera}}</option>
																</select>

															</div>

															<!-- CILINDRO -->
															<div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 mb-2">

																<label class="form-label" for="LenteCCilindro"><b class="text-danger">*</b> Cilindro</label>
																<select v-model="objTblLenteContacto.Cilindro" class="form-control-search form-select" id="LenteCCilindro" :disabled="blockCilindro">
																	<option value="">Seleccione una opción</option>
																	<option v-for="(item, index) in ListaCilindrosSelect.Multiple" :key="index" :value="item.RangoCilindro">{{item.RangoCilindro}}</option>
																</select>

															

															</div>

															<div v-if="articuloWebSelect.ReqEjeAdd == 'Eje' " class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="LenteCEje">Eje</label>
																<treeselect v-model="objTblLenteContacto.Eje"
																	:value-consists-of="'ALL_WITH_INDETERMINATE'"
																	:multiple="false"
																	:options="ListaEjesLenteC"
																	
																	:show-count="true"
																	:clearable="false"
																	:noResultsText="'No se encontraron resultados'"
																	placeholder="Selecciona una opción"/>
															</div>

															<!-- RANGO ADICIONAL DERECHA -->
															<div v-if="articuloWebSelect.ReqEjeAdd == 'Adicion'" class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="LenteCAdicion">*Adición</label>
																<treeselect v-model="objTblLenteContacto.Adicion"
																	:value-consists-of="'ALL_WITH_INDETERMINATE'"
																	:multiple="false"
																	:options="ListaAdicionLenteC"
																	
																	:show-count="true"
																	:clearable="false"
																	:noResultsText="'No se encontraron resultados'"
																	placeholder="Selecciona una opción"/>
															</div>

															<!-- CANTIDAD -->
															<div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
																<label class="form-label" for="LenteCCantidad"><b class="text-danger">*</b> Cantidad</label>
																<input @input="$onlyNums($event,objTblLenteContacto,'Cantidad')" type="text" v-model="objTblLenteContacto.Cantidad" class="form-control" id="LenteCCantidad"/>
															</div>


															<!-- BOTON -->
															<div class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
																<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																<div class="d-grid gap-2 col-12 mx-auto">
																	<button type="button" class="btn btn-warning" @click="agregarLenteContacto()">
																		<i class="fa fa-plus-circle"></i> Agregar
																	</button>
																</div>
																
															</div>
														</div>


														<div v-if="listaDetalleLenteC.length > 0" class="row mt-2">
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
																<div class="table-responsive">
																	<table class="table">
																		<thead>
																			<th>Articulo</th>
																			<th>Esfera</th>
																			<th>Cilindro</th>
																			<th>Eje</th>
																			<th>Adicion</th>
																			<th>Color</th>
																			<th>Cantidad</th>
																			<th>Eliminar</th>
																		</thead>
																		<tbody>
																			<tr v-for="(itemtbl,indxtbl) in listaDetalleLenteC"  :key="indxtbl">
																				<td>{{ itemtbl.Descripcion }}</td>
																				<td>{{ itemtbl.Esfera }}</td>
																				<td>{{ itemtbl.Cilindro }}</td>
																				<td>{{ itemtbl.Eje }}<span v-if="itemtbl.Eje != ''">°</span></td>
																				<td><i v-if="parseFloat(itemtbl.Adicion) >= 0" class="fas fa-plus fa-xs"></i> <b>{{ itemtbl.Adicion }}</b> </td>
																				<td><i v-if="itemtbl.NombreColor != '' && itemtbl.NombreColor != null" :title="itemtbl.NombreColor" v-b-tooltip.hover class="fas fa-circle fa-lg" :style="'color:'+itemtbl.Color+';'"></i> {{ itemtbl.NombreColor }}</td>
																				<td>{{ itemtbl.Cantidad }}</td>
																				<td>
																					<a class="btn btn-link text-warning px-3 mb-0 mr-1" @click="eliminarLentesContacto(indxtbl)">
																						<i class="fa fa-trash"></i> Eliminar
																					</a>
																				</td>
																			</tr>
																			
																		</tbody>
																	</table>
																</div>
															</div>
														</div>
														

													</template>


													<!-- ******************** TERMINA BLOQUE FUNCIONAL SOLO PARA PROCESO #3 ******************** -->

													<div v-show="this.objPedido.IdTipoLente > 0" class="row mt-4">
														<div class="col-12 text-end">
															<button @click="cambiarPaso(1)" type="button" class="btn btn-secondary me-2">Anterior</button>
															<button v-if="procesoActivo == 1" @click="cambiarPaso(3)" type="button" class="btn btn-primary">Siguiente</button>
															<button v-if="procesoActivo == 2 && objPedido.NumPar == 1 && bndCalculoPrecioLT === true" @click="cambiarPaso(3)" type="button" class="btn btn-primary">Siguiente</button>
															<button v-if="procesoActivo == 2 && objPedido.NumPar == 2 && unlockBtnSave === true" class="btn btn-warning me-2" @click="viewResumen()">Siguiente</button>
															<button v-if="procesoActivo == 3 && unlockBtnSave === true" class="btn btn-warning me-2" @click="viewResumen()">Siguiente</button>
														</div>
													</div>

												</div>
												<!-- END PASO 2 -->
												
												<!-- PASO 3 -->
												<div  v-if="showPasos.paso3" class="mt-2" >
													<h5 class="card-title" id="confArmazon">Configuración de Armazón</h5>

													<div class="row mt-2">

														<div class="col-2">
															<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
															<div class="form-check form-switch">
																<input v-model="objPedido.EnviaArmazon" @change="setBiselesActivos(true)" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
																<label class="form-check-label" for="CambioForma">Envia Armazón</label>
															</div>
														</div>

														<template v-if="objPedido.EnviaArmazon">
															<div class="col-4">
																<h6>Estado del Armazón</h6>
																<div class="form-check form-check-inline">
																	<input v-model="objPedido.EstadoArmazon" class="form-check-input" type="radio" name="EstadoArmazon" id="EstadoArmazon1" value="Nuevo">
																	<label class="form-check-label" for="EstadoArmazon1">Nuevo</label>
																</div>
																<div class="form-check form-check-inline">
																	<input v-model="objPedido.EstadoArmazon" class="form-check-input" type="radio" name="EstadoArmazon" id="EstadoArmazon2" value="Usado">
																	<label class="form-check-label" for="EstadoArmazon2">Usado</label>
																</div>
																<CValidation v-if="this.errorvalidacion.EstadoArmazon" :Mensaje="'*'+errorvalidacion.EstadoArmazon[0]"/>
															</div>
															
															<div class="col-2">
																<label class="form-label" for="MarcaArmazon">*Marca</label>
																<input type="text" v-model="objPedido.MarcaArmazon" class="form-control" id="MarcaArmazon" placeholder="" />
																<CValidation v-if="this.errorvalidacion.MarcaArmazon" :Mensaje="'*'+errorvalidacion.MarcaArmazon[0]"/>
															</div>

															<div class="col-2">
																<label class="form-label" for="ModeloArmazon">*Modelo</label>
																<input type="text" v-model="objPedido.ModeloArmazon" class="form-control" id="ModeloArmazon" placeholder="" />
																<CValidation v-if="this.errorvalidacion.ModeloArmazon" :Mensaje="'*'+errorvalidacion.ModeloArmazon[0]"/>
															</div>

															<div class="col-2">
																<label class="form-label" for="ColorArmazon">*Color</label>
																<input type="text" v-model="objPedido.ColorArmazon" class="form-control" id="ColorArmazon" placeholder="" />
																<CValidation v-if="this.errorvalidacion.ColorArmazon" :Mensaje="'*'+errorvalidacion.ColorArmazon[0]"/>
															</div>
														</template>
								
													</div>
													<br>

													<template v-if="procesoActivo != 2">
														<div class="row">

															<h6><span class="text-red">*</span> Tipo de Armazón</h6>
														
															<div class="col-auto" v-for="(item, indexarmazones) in ListaArmazones" :key="indexarmazones">
																<div class=" form-check-inline form-check form-switch form-sw">
																	<input v-model="objPedido.IdArmazon" @change="setBiselesActivos()" class="form-check-input" type="radio" role="switch" :value="item.IdArmazon" :id="'idswitchtparmazon'+item.IdArmazon" >
																	<label class="form-check-label" for="flexSwitchCheckDefault">{{ item.Nombre }}</label>
																</div>
															</div>

															<CValidation v-if="this.errorvalidacion.IdArmazon" :Mensaje="'*'+errorvalidacion.IdArmazon[0]"/>
															
														</div>
														<br>

														<div class="row mt-1">
															<div class="col-12 col-lg-4 col-xl-3">
																<img src="@/assets/style/image/duarte-02.png" alt="Logo" style="width: 95%;" class="">
															</div>

															<div class="col-12 col-lg-4 col-xl-2">
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="DBL">* DBL</label>
																		<input type="text" v-model="objPedido.DBL" @input="$onlyNums($event,objPedido,'DBL')" class="form-control" id="DBL" />
																		<CValidation v-if="this.errorvalidacion.DBL" :Mensaje="'*'+errorvalidacion.DBL[0]"/>
																	</div>
																</div>
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="ED">* ED</label>
																		<input type="text" v-model="objPedido.ED" @input="$onlyNums($event,objPedido,'ED')" class="form-control" id="ED" />
																		<CValidation v-if="this.errorvalidacion.ED" :Mensaje="'*'+errorvalidacion.ED[0]"/>
																	</div>
																</div>
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="B">* B</label>
																		<input type="text" v-model="objPedido.B" @input="$onlyNums($event,objPedido,'B')" class="form-control" id="B" />
																		<CValidation v-if="this.errorvalidacion.B" :Mensaje="'*'+errorvalidacion.B[0]"/>
																	</div>
																</div>
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="A">A</label>
																		<input type="text" v-model="objPedido.A" @input="$onlyNums($event,objPedido,'A')" class="form-control" id="A" />
																		<CValidation v-if="this.errorvalidacion.A" :Mensaje="'*'+errorvalidacion.A[0]"/>
																	</div>
																</div>
															</div>

															<div class="col-12 col-lg-4 col-xl-7">
																<div class="row">
																	<template v-if="objPedido.EnviaArmazon == true">
																		<div class="col-5">
									
																			<label class="form-label" for="IdBisel">Bisel</label>
																			<select v-model="objPedido.IdBisel" @change="getMateriales()" class="form-control-search form-select" id="IdBisel" disabled >
																				<option :value="0">Seleccione una opción</option>
																				<option v-for="(item, index) in getBiselesFilter('SI')" :key="index" :value="item.IdBisel">{{item.Nombre}}</option>
																			</select>
																			<CValidation v-if="this.errorvalidacion.IdArmazon" :Mensaje="'*'+errorvalidacion.IdArmazon[0]"/>
																		</div>

																		<div v-for="(item, index) in getBiselesFilter('NO')" :key="index"  class="col-2">
																			<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																			<div class="form-check form-switch">
																				<input v-model="objPedido.UsaBiselSencillo" @change="calculaCostoBiselSencillo(item.IdBisel)" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
																				<label class="form-check-label" for="CambioForma">{{ item.Nombre }}</label>
																			</div>
																		</div>
																	</template>
																</div>
																<div class="row">
																	<div class="col-4">
																		<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																		<div class="form-check form-switch">
																			<input v-model="objPedido.CambioForma" @change="calculaCostoForma()" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
																			<label class="form-check-label" for="CambioForma">Requiere cambio de forma</label>
																		</div>
																	</div>
																	<template v-if="objPedido.CambioForma == true">
																		<div class="col-4">
																			<label class="form-label" for="EscanearForma">Escanear Forma</label>
																			<input type="text" v-model="objPedido.EscanearForma" class="form-control" id="EscanearForma" placeholder="" />
																			<CValidation v-if="this.errorvalidacion.EscanearForma" :Mensaje="'*'+errorvalidacion.EscanearForma[0]"/>
																		</div>
																		
																		<div class="col-4">
																			<label class="form-label" for="MontarArmazon">Montar en Armazon</label>
																			<input type="text" v-model="objPedido.MontarArmazon" class="form-control" id="MontarArmazon" placeholder="" />
																			<CValidation v-if="this.errorvalidacion.MontarArmazon" :Mensaje="'*'+errorvalidacion.MontarArmazon[0]"/>
																		</div>
																		
																	</template>
																	
																</div>

																<div v-if="objPedido.CambioForma == true" class="row">
																	<div class="col-12">
																		<h6>Realizar Aumentos</h6>
																		<div class="form-check form-check-inline">
																			<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida1" value="NO">
																			<label class="form-check-label" for="AumentarMedida1">NO</label>
																		</div>
																		<div class="form-check form-check-inline">
																			<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida2" value="AumentarMedida">
																			<label class="form-check-label" for="AumentarMedida2">Aumentar medidas</label>
																		</div>
																		<div class="form-check form-check-inline">
																			<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida3" value="AumentarContorno">
																			<label class="form-check-label" for="AumentarMedida3">Aumentar contorno</label>
																		</div>
																	</div>
																	
																</div>
																
																<div class="row">
																	<template v-if="objPedido.CambioForma == true && objPedido.AumentarMedida == 'AumentarMedida'">															
																		<div class="col-3">
																			<label class="form-label" for="AumentarArriba">Arriba (mm)</label>
																			<input type="text" v-model="objPedido.AumentarArriba" @input="$onlyNums($event,objPedido,'AumentarArriba')" class="form-control" id="AumentarArriba" />
																			<CValidation v-if="this.errorvalidacion.AumentarArriba" :Mensaje="'*'+errorvalidacion.AumentarArriba[0]"/>
																		</div>
																		<div class="col-3">
																			<label class="form-label" for="AumentaAbajo">Abajo (mm)</label>
																			<input type="text" v-model="objPedido.AumentaAbajo" @input="$onlyNums($event,objPedido,'AumentaAbajo')" class="form-control" id="AumentaAbajo" />
																			<CValidation v-if="this.errorvalidacion.AumentaAbajo" :Mensaje="'*'+errorvalidacion.AumentaAbajo[0]"/>
																		</div>
																		<div class="col-3">
																			<label class="form-label" for="AumentaDerecho">Temporal (mm)</label>
																			<input type="text" v-model="objPedido.AumentaDerecho" @input="$onlyNums($event,objPedido,'AumentaDerecho')" class="form-control" id="AumentaDerecho" />
																			<CValidation v-if="this.errorvalidacion.AumentaDerecho" :Mensaje="'*'+errorvalidacion.AumentaDerecho[0]"/>	
																		</div>
																	</template>
																	<div v-if="objPedido.CambioForma == true && objPedido.AumentarMedida == 'AumentarContorno'" class="col-3">
																		<label class="form-label" for="Contorno">Contorno (mm)</label>
																		<input type="text" v-model="objPedido.Contorno" @input="$onlyNums($event,objPedido,'Contorno')" class="form-control" id="Contorno" />
																		<CValidation v-if="this.errorvalidacion.Contorno" :Mensaje="'*'+errorvalidacion.Contorno[0]"/>
																	</div>
																</div>

																
																<div  class="row">
																	<div class="col-4">
																		<label class="form-label" for="">&nbsp;</label><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																		<div class="form-check form-switch">
																			<input v-model="objPedido.ReqTinte" @change="calculaCostoEntintado()" class="form-check-input" type="checkbox" role="switch" id="ReqTinte">
																			<label class="form-check-label" for="ReqTinte">Requiere entintado:</label>
																		</div>
																	</div>
																</div>

																<template v-if="objPedido.ReqTinte == true">
																	<div class="row mt-2">
																		<div class="col-12">
																			<h6 class="card-title">Color</h6>
																			<div v-for="(item7,idexcolor) in ListaColores" :key="idexcolor"  class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.IdColor" :style="'background-color:'+item7.Color+';'" :id="'ilRadioColor'+item7.IdColor" :value="item7.IdColor" 
																				:title="item7.Nombre" v-b-tooltip.hover class="form-check-input lente" type="radio" name="inlineRadioOptions" >
																				<!--<label class="form-check-label" :for="'ilRadioColor'+item7.IdColor">{{ item7.Nombre }}</label>-->
																			</div>
																		</div>
																	</div>

																	<div class="row mt-2">
																		<div class="col-12">
																			<h6 class="card-title">Tono</h6>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Tono" style="background: #c3c4c5;" id="ilRadioTono" :value="1" 
																				title="Tono 1" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono1" >
																				<label class="form-check-label" for="ilRadioTono1">1</label>
																			</div>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Tono" style="background: #9e9fa0;" id="ilRadioTono" :value="2" 
																				title="Tono 2" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono2" >
																				<label class="form-check-label" for="ilRadioTono2">2</label>
																			</div>

																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Tono" style="background: #6a6a6b;" id="ilRadioTono" :value="3" 
																				title="Tono 3" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono3" >
																				<label class="form-check-label" for="ilRadioTono3">3</label>
																			</div>
																		</div>
																	</div>

																	<div class="row mt-2">
																		<div class="col-12">
																			<h6 class="card-title">Coloracion</h6>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Coloracion" style="background: #c3c4c5;" id="ilRadioColoracion" :value="1" 
																				title="Uniforme" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioColoracion1" >
																				<label class="form-check-label" for="ilRadioColoracion1">Uniforme</label>
																			</div>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Coloracion" style="background: rgb(87,87,92); background: linear-gradient(180deg, rgba(87,87,92,1) 0%, rgba(207,207,207,1) 61%, rgba(254,254,254,1) 100%);" id="ilRadioColoracion" :value="2" 
																				title="Desvanecido" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioColoracion2" >
																				<label class="form-check-label" for="ilRadioColoracion2">Desvanecido</label>
																			</div>
																		</div>
																	</div>
																</template>

																<div class="row mt-2">
																	<div class="col-12">
																		<label class="form-label" for="ObservacionesGeneral">Observaciones Generales</label>
																		<textarea v-model="objPedido.ObservacionesGeneral" class="form-control" rows="2"></textarea>
																	</div>
																</div>

															</div>
														</div>
													</template>
													<template v-else-if="procesoActivo == 2">
					
														<div v-if="objPedido.EnviaArmazon == true" class="row">
															
															<h6><span class="text-red">*</span> Tipo de Armazón</h6>
														
															<div class="col-auto" v-for="(item, indexarmazones) in ListaArmazones" :key="indexarmazones">
																<div class=" form-check-inline form-check form-switch form-sw">
																	<input v-model="objPedido.IdArmazon" @change="setBiselesActivos()" class="form-check-input" type="radio" role="switch" :value="item.IdArmazon" :id="'idswitchtparmazon'+item.IdArmazon" >
																	<label class="form-check-label" for="flexSwitchCheckDefault">{{ item.Nombre }}</label>
																</div>
															</div>

															<CValidation v-if="this.errorvalidacion.IdArmazon" :Mensaje="'*'+errorvalidacion.IdArmazon[0]"/>
															
														</div>
														<br>

														<div class="row">
															<div v-if="objPedido.EnviaArmazon == true" class="col-12 col-lg-4 col-xl-3">
																<img src="@/assets/style/image/duarte-02.png" alt="Logo" style="width: 95%;" class="">
															</div>

															<div v-if="objPedido.EnviaArmazon == true" class="col-12 col-lg-4 col-xl-2">
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="DBL">* DBL</label>
																		<input type="text" v-model="objPedido.DBL" @input="$onlyNums($event,objPedido,'DBL')" class="form-control" id="DBL" />
																		<CValidation v-if="this.errorvalidacion.DBL" :Mensaje="'*'+errorvalidacion.DBL[0]"/>
																	</div>
																</div>
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="ED">* ED</label>
																		<input type="text" v-model="objPedido.ED" @input="$onlyNums($event,objPedido,'ED')" class="form-control" id="ED" />
																		<CValidation v-if="this.errorvalidacion.ED" :Mensaje="'*'+errorvalidacion.ED[0]"/>
																	</div>
																</div>
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="B">* B</label>
																		<input type="text" v-model="objPedido.B" @input="$onlyNums($event,objPedido,'B')" class="form-control" id="B" />
																		<CValidation v-if="this.errorvalidacion.B" :Mensaje="'*'+errorvalidacion.B[0]"/>
																	</div>
																</div>
																<div class="row">
																	<div class="col-12">
																		<label class="form-label" for="A">A</label>
																		<input type="text" v-model="objPedido.A" @input="$onlyNums($event,objPedido,'A')" class="form-control" id="A" />
																		<CValidation v-if="this.errorvalidacion.A" :Mensaje="'*'+errorvalidacion.A[0]"/>
																	</div>
																</div>
															</div>

															<div class="col-12 col-lg-4 col-xl-7">
																<div class="row" v-if="objPedido.EnviaArmazon == true">
																	
																	<div class="col-3">
																		<label class="form-label" for="IdBisel">Bisel</label>
																		<select v-model="objPedido.IdBisel" @change="getMateriales()" class="form-control-search form-select" id="IdBisel" disabled >
																			<option :value="0">Seleccione una opción</option>
																			<option v-for="(item, index) in getBiselesFilter('SI')" :key="index" :value="item.IdBisel">{{item.Nombre}}</option>
																		</select>
																		<CValidation v-if="this.errorvalidacion.IdArmazon" :Mensaje="'*'+errorvalidacion.IdArmazon[0]"/>
																	</div>

																	<div v-for="(item, index) in getBiselesFilter('NO')" :key="index"  class="col-2">
																		<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																		<div class="form-check form-switch">
																			<input v-model="objPedido.UsaBiselSencillo" @change="calculaCostoBiselSencillo(item.IdBisel)" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
																			<label class="form-check-label" for="CambioForma">{{ item.Nombre }}</label>
																		</div>
																	</div>
															

																</div>

																<div v-if="objPedido.EnviaArmazon == true" class="row">
																	<div class="col-4">
																		<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																		<div class="form-check form-switch">
																			<input v-model="objPedido.CambioForma" @change="calculaCostoForma()" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
																			<label class="form-check-label" for="CambioForma">Requiere cambio de forma</label>
																		</div>
																	</div>
																	<template v-if="objPedido.CambioForma == true">
																		<div class="col-4">
																			<label class="form-label" for="EscanearForma">Escanear Forma</label>
																			<input type="text" v-model="objPedido.EscanearForma" class="form-control" id="EscanearForma" placeholder="Ingresar EscanearForma" />
																			<CValidation v-if="this.errorvalidacion.EscanearForma" :Mensaje="'*'+errorvalidacion.EscanearForma[0]"/>
																		</div>
																		
																		<div class="col-4">
																			<label class="form-label" for="MontarArmazon">Montar en Armazon</label>
																			<input type="text" v-model="objPedido.MontarArmazon" class="form-control" id="MontarArmazon" placeholder="Ingresar MontarArmazon" />
																			<CValidation v-if="this.errorvalidacion.MontarArmazon" :Mensaje="'*'+errorvalidacion.MontarArmazon[0]"/>
																		</div>
																		
																	</template>
																	
																</div>

																<div v-if="objPedido.CambioForma == true" class="row">
																	<div class="col-12">
																		<h6>Realizar Aumentos</h6>
																		<div class="form-check form-check-inline">
																			<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida1" value="NO">
																			<label class="form-check-label" for="AumentarMedida1">NO</label>
																		</div>
																		<div class="form-check form-check-inline">
																			<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida2" value="AumentarMedida">
																			<label class="form-check-label" for="AumentarMedida2">Aumentar medidas</label>
																		</div>
																		<div class="form-check form-check-inline">
																			<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida3" value="AumentarContorno">
																			<label class="form-check-label" for="AumentarMedida3">Aumentar contorno</label>
																		</div>
																	</div>
																	
																</div>
																
																<div class="row">
																	<template v-if="objPedido.CambioForma == true && objPedido.AumentarMedida == 'AumentarMedida'">															
																		<div class="col-3">
																			<label class="form-label" for="AumentarArriba">Arriba (mm)</label>
																			<input type="text" v-model="objPedido.AumentarArriba" @input="$onlyNums($event,objPedido,'AumentarArriba')" class="form-control" id="AumentarArriba" />
																			<CValidation v-if="this.errorvalidacion.AumentarArriba" :Mensaje="'*'+errorvalidacion.AumentarArriba[0]"/>
																		</div>
																		<div class="col-3">
																			<label class="form-label" for="AumentaAbajo">Abajo (mm)</label>
																			<input type="text" v-model="objPedido.AumentaAbajo" @input="$onlyNums($event,objPedido,'AumentaAbajo')" class="form-control" id="AumentaAbajo" />
																			<CValidation v-if="this.errorvalidacion.AumentaAbajo" :Mensaje="'*'+errorvalidacion.AumentaAbajo[0]"/>
																		</div>
																		<div class="col-3">
																			<label class="form-label" for="AumentaDerecho">Temporal (mm)</label>
																			<input type="text" v-model="objPedido.AumentaDerecho" @input="$onlyNums($event,objPedido,'AumentaDerecho')" class="form-control" id="AumentaDerecho" />
																			<CValidation v-if="this.errorvalidacion.AumentaDerecho" :Mensaje="'*'+errorvalidacion.AumentaDerecho[0]"/>	
																		</div>
																	</template>
																	<div v-if="objPedido.CambioForma == true && objPedido.AumentarMedida == 'AumentarContorno'" class="col-3">
																		<label class="form-label" for="Contorno">Contorno (mm)</label>
																		<input type="text" v-model="objPedido.Contorno" @input="$onlyNums($event,objPedido,'Contorno')" class="form-control" id="Contorno" />
																		<CValidation v-if="this.errorvalidacion.Contorno" :Mensaje="'*'+errorvalidacion.Contorno[0]"/>
																	</div>
																</div>

																
																<div  class="row">
																	<div class="col-4">
																		<label class="form-label" for="">&nbsp;</label><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																		<div class="form-check form-switch">
																			<input v-model="objPedido.ReqTinte" @change="calculaCostoEntintado()" class="form-check-input" type="checkbox" role="switch" id="ReqTinte">
																			<label class="form-check-label" for="ReqTinte">Requiere entintado:</label>
																		</div>
																	</div>
																</div>

																<template v-if="objPedido.ReqTinte == true">
																	<div class="row mt-2">
																		<div class="col-12">
																			<h6 class="card-title">Color</h6>
																			<div v-for="(item7,idexcolor) in ListaColores" :key="idexcolor"  class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.IdColor" :style="'background-color:'+item7.Color+';'" :id="'ilRadioColor'+item7.IdColor" :value="item7.IdColor" 
																				:title="item7.Nombre" v-b-tooltip.hover class="form-check-input lente" type="radio" name="inlineRadioOptions" >
																				<!--<label class="form-check-label" :for="'ilRadioColor'+item7.IdColor">{{ item7.Nombre }}</label>-->
																			</div>
																		</div>
																	</div>

																	<div class="row mt-2">
																		<div class="col-12">
																			<h6 class="card-title">Tono</h6>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Tono" style="background: #c3c4c5;" id="ilRadioTono" :value="1" 
																				title="Tono 1" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono1" >
																				<label class="form-check-label" for="ilRadioTono1">1</label>
																			</div>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Tono" style="background: #9e9fa0;" id="ilRadioTono" :value="2" 
																				title="Tono 2" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono2" >
																				<label class="form-check-label" for="ilRadioTono2">2</label>
																			</div>

																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Tono" style="background: #6a6a6b;" id="ilRadioTono" :value="3" 
																				title="Tono 3" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono3" >
																				<label class="form-check-label" for="ilRadioTono3">3</label>
																			</div>
																		</div>
																	</div>

																	<div class="row mt-2">
																		<div class="col-12">
																			<h6 class="card-title">Coloracion</h6>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Coloracion" style="background: #c3c4c5;" id="ilRadioColoracion" :value="1" 
																				title="Uniforme" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioColoracion1" >
																				<label class="form-check-label" for="ilRadioColoracion1">Uniforme</label>
																			</div>
																			<div class="form-check form-check-inline mb-2">
																				<input v-model="objPedido.Coloracion" style="background: rgb(87,87,92); background: linear-gradient(180deg, rgba(87,87,92,1) 0%, rgba(207,207,207,1) 61%, rgba(254,254,254,1) 100%);" id="ilRadioColoracion" :value="2" 
																				title="Desvanecido" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioColoracion2" >
																				<label class="form-check-label" for="ilRadioColoracion2">Desvanecido</label>
																			</div>
																		</div>
																	</div>
																</template>

																<div class="row mt-2">
																	<div class="col-12">
																		<label class="form-label" for="ObservacionesGeneral">Observaciones Generales</label>
																		<textarea v-model="objPedido.ObservacionesGeneral" class="form-control" rows="2"></textarea>
																	</div>
																</div>

															</div>
														</div>
													</template>

													<div v-show="this.objPedido.IdTipoLente > 0" class="row mt-4">
														<div class="col-12 text-end">
															<button @click="cambiarPaso(2)" type="button" class="btn btn-secondary me-2">Anterior</button>
															<button v-if="unlockBtnSave === true" class="btn btn-warning me-2" @click="viewResumen()">Siguiente</button>
														</div>
													</div>

												</div>

											</div>
										</div>
										
									</div>
								</div>	


								<div class="row mt-2" >
									<div class="col-12">
										<div class="card">
											<div class="card-body">
												<h5 class="card-title">Resumen de Costos</h5>
												<div class="row">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
														<div class="table-responsive">
															<table class="table">
																<thead>
																	<tr>
																		<th>CLAVE</th>
																		<th>Producto</th>																	
																		<th class="text-center">Tipo</th>
																		<th class="text-end">Precio</th>
																		<th class="text-end">Cantidad</th>
																		<th class="text-end">Descuento</th>
																		<th class="text-end">Importe</th>
																		
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(item,idnx) in detallePedido" :key="idnx">
																		<td style="vertical-align: middle !important;">{{ item.Clave }}</td>
																		<td style="vertical-align: middle !important;"><b>{{ item.Descripcion }}</b></td>
																		<td class="text-center" style="vertical-align: middle !important;"> 
																			<template v-if="item.TipoDet == 'Proteccion'">Artículo</template> 
																			<template v-else>{{ item.TipoDet }}</template>
																		</td>
																		<td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.Precio,'$') }}</td>
																		<td class="text-end" style="vertical-align: middle !important;">{{ item.Cantidad }}</td>
																		<td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.PrecioDesc,'$') }}</td>
																		<td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.Importe,'$') }}</td>
																		
																	</tr>
																
																</tbody>

																<tfoot class="text-end">
																	<tr>
																		<td colspan="5"></td>
																		<td><h6>Subtotal</h6></td>
																		<td>{{ $formatNumber(this.objPedido.SubTotal,'$') }}</td>
																	</tr>

																	<tr>
																		<td colspan="5"></td>
																		<td><h6>Descuentos</h6></td>
																		<td>{{ $formatNumber(this.objPedido.Descuento,'$') }}</td>
																	</tr>

																	<tr>
																		<td colspan="5"></td>
																		<td><h6>IVA</h6></td>
																		<td>{{ $formatNumber(this.objPedido.Iva,'$') }}</td>
																	</tr>
																	
																	<tr>
																		<td colspan="5"></td>
																		<td><h5>Total</h5></td>
																		<td><h5>{{ $formatNumber(this.objPedido.GranTotal,'$') }}</h5></td>
																	</tr>
																</tfoot>

															</table>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								
								
														
								<br>
								
							</form>
							<CBtnSave :poBtnSave="oBtnSave">
								<template slot="btnsaveextra">
									<!--<button v-if="unlockBtnSave === true && (objPedido.Estatus == 'Cotizacion' || objPedido.Estatus == '') " type="button" class="btn mr-1" style="background-color:#7DCEA0; color:#FFF;" @click="Guardar('Cotizacion')">
										<i class="fas fa-save"></i>
										Guardar como Cotización
									</button> -->
								</template>
							</CBtnSave>
						</div>




					</template>
				</CLoader>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModalResumen" :poBtnSave="oBtnSaveResumen">
			<template slot="Form">
				<ResumenPedido :poBtnSave="oBtnSaveResumen" :pOrigen="'Form'"></ResumenPedido>
			</template>
			<template slot="BtnExtraModal">

				<button v-if="(objPedido.Estatus == 'Cotizacion' || objPedido.Estatus == '') " type="button" class="btn mr-1" 
					style="background-color:#7DCEA0; color:#FFF;" @click="Guardar('Cotizacion')">
					<i class="fas fa-save"></i>
					Guardar como Cotización
				</button>

			</template>
		</CModal>

	</div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
import BuscadorCliente from '@/components/BuscadorCliente.vue';
import StaticComboBox from '@/helpers/StaticComboBox';
import ResumenPedido from './ResumenPedido.vue';

const EmitEjecuta = 'seccionPedido';
const EmitEjecuta2 = 'seccionFormResumenPedido';

export default {
    name: 'FormPedido',
    props: ['Id','Obj'],
    components:{
		BuscadorCliente,
		ResumenPedido
    },
    data() {
        return {
			ConfigModalResumen:{
                ModalTitle: "Resumen de Pedido",
                ModalNameId: 'ModalForm7',
                ModalSize: 'xl',
                EmitSeccion: EmitEjecuta2,
            },

            oBtnSaveResumen:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                ShowBtnSave: true,
				IconBtnSave: 'fas fa-paper-plane',
				TxtBtnSave: 'Guardar y Enviar Pedido',
                TxtBtnCancel: 'Cerrar',
                EmitSeccion: EmitEjecuta2,
            },

			ConfigList:{
                Title: 'Crear Nuevo Pedido',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: '',
                EmitSeccion: EmitEjecuta,
				TxtBtnSave: 'Guardar',
				IconBtnSave: '',
				ShowBtnSave: false
            },
			unlockBtnSave: false,

			locationForm: '',

			showPasos: {
				paso1: false,
				paso2: false,
				paso3: false, 
			},

			showBtnNextStep: true,

            objPedido: {
				IdPedido: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdSubLinea: 0,
				IdArticuloWeb: 0,
				IdMaterial: 0,
				IdProteccion: 0,
				IdRecubrimiento: 0,
				IdArmazon: 0,
				IdBisel: 0,
				IdTipoLente: 0,
				Estatus: '',
				FolioCotizacion: '',
				FolioPedido: '',
				Fecha: '',
				Paciente: '',

				OjoDerecho: true,
				OdEsfera: '',
				OdCilindro: '',
				OdEje: '',
				OdAdicion: '',
				OdPrisma: '',
				OdDnp: '',
				OdAltMon: '',
				OdAltSeg: '',
				OdPosicion: '',

				OjoIzquierdo: true,
				OiEsfera: '',
				OiCilindro: '',
				OiEje: '',
				OiAdicion: '',
				OiPrisma: '',
				OiDnp: '',
				OiAltMon: '',
				OiAltSeg: '',
				OiPosicion: '',

				ReqTinte: '',
				IdColor: 0,
				Color: '',
				Tono: '',
				Coloracion: '',
				NumPar: 0,
			
				UsaBiselSencillo: false,
				IdBiselSencillo: 0,
				IdSubBisel: 0,
				NumGrapas: 0,

				Perforacion: '',
				
				ObservacionesGeneral: '',
				SubLinea: '',
				Articulo: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				Armazon: '',
				AnguloPantoscopico: '',
				AnguloPanoramico: '',
				DistanciaVertice: '',
				DistanciaLectura: '',
				Iniciales: '',
				AlturaSegmento: '',

				// PASO 3
				EnviaArmazon: false,
				MarcaArmazon: '',
				ColorArmazon: '',
				ModeloArmazon: '',
				EstadoArmazon: '',

				CambioForma: '',
				EscanearForma: '',
				MontarArmazon: '',
				AumentarArriba: '',
				AumentaAbajo: '',
				AumentaDerecho: '',
				Contorno: '',
				DBL: '',
				ED: '',
				B: '',
				A: '',
				AumentarMedida: 'NO',
				
				SubTotal: 0,
				Descuento: 0,
				Iva: 0,
				GranTotal: 0,
				FolioEnviado: '',
				Insertado: '',
            },

			detallePedido: [],
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
			Emit: EmitEjecuta2,

			showAlertCliente: false,
			bndClienteReady: false,
			bndClientebyKey: false,
			bndClientebyName: false,
			objCliente:{
				IdCliente:'',
				Clave:'',
				Nombre:''
			},

			/***************** TIPO LENTES *****************/
			
			
			ListaTipoLentes:[],
			ListPosicionesLentes: StaticComboBox.PosicionesLentes,
			TpLenteSelect: {
				IdTipoLente: 0,
				Nombre:"",
				Clave:"",
				Proceso:"0",
				Esfera:"NO",
				Cilindro:"NO",
				Eje:"NO",
				Adicion:"NO",
				AltMon:"NO",
				AltSeg:"NO",
				Dnp:"NO",
				Prisma:"NO",
				Posicion:"NO",
				ValMinMon:"0",
				ValMaxMon:"0",
				ValMinSeg:"0",
				ValMaxSeg:"0",
				Esferas:{
					Maximo: 0,
					Minimo: 0,
				},
				Cilindros:{
					Maximo: 0,
					Minimo: 0,
				},
				Adicionales:{
					Maximo: 0,
					Minimo: 0,
				},
			},
			lentesSinSubLinea:[2,3,10], //includes 11
			procesoActivo: 0,
			showNumParesLentes: false,


			/***************** TABLA DE RX *****************/
			showRXLentes: false,

			// CONTROL DE ESFERAS 
			EsferaDerecha:{
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			EsferaIzquierda:{
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			// CONTROL DE CILINDROS 
			CilindroDerecho: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
				blockEje: true,
			},
			CilindroIzquierdo: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
				blockEje: true
			},

			// CONTROL DE RANGOS ADICIONALES
			RanAdicionalDerecho: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},
			RanAdicionalIzquierdo: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			toolTipRX: {
				// EJE
				showToolOdEje: 			false,
				showToolOdEjeRequire: 	false,
				showToolOiEje: 			false,
				showToolOiEjeRequire: 	false,

				// ALT MONTURA
				showToolOdAltMon: 		false,
				showToolOiAltMon: 		false,

				// ALT SEGMENTO
				showToolOdAltSeg: 		false,
				showToolOiAltSeg: 		false,
				showToolAltSegSecundario: false,

				// DNP
				showToolOdDnp: 			false,
				showToolOiDnp: 			false,

				// PRISMA
				showToolOdPrisma: 		false,
				showToolOiPrisma: 		false,

				// SECCION DE PERSONALIZACION
				showToolAngPantos: 		false,
				showToolAngPanoram: 	false,
				showToolDistVertice: 	false,
				showToolDistLectura: 	false,
				showToolIniciales: 		false,
				showPopArticulo: 		false,
				showPopMaterial: 		false,
			},

			// SUBLINEAS
			ListaSublineas: [],

			// ARTICULOS WEB
			showArticulos: false,
			bndBloqueoArticulo: false,
			ListaArticulosWeb: [],
			articuloWebSelect: {
				IdArticuloWeb: 0,
				IdSublinea: 0,
				IdTipoLente: 0,
				Nombre: "",
				Clave: "",
				ReqTratExt: "NO",
				ReqTratamiento: "NO",
				AnguloPantoscopico: "NO",
				AnguloPanoramico: "NO",
				DistanciaVertice: "NO",
				DistanciaLectura: "NO",
				Iniciales: "NO",
				ReqTratInt: "NO",
				ReqEjeAdd: "NO",
				SolicitaListado: "",
				ViewSeccion: false,
				Seleccionable: true,
			},


			// MATERIALES
			ListaMateriales: [],
			bndBloqueoMaterial: false,
			materialSelect: {
				Seleccionable: '',
				RazonBloqueo: ''
			},

			// PROTECCIONES
			bndBloqueoProtxRecub: true,
			showProteccion: false,
			ListaProtecciones: [],

			// RECUBRIMIENTOS
			showRecubrimiento: false,
			ListaRecubrimientos: [],

			// ARMAZONES
			ListaArmazones: [],

			// BISELES
			ListaBiseles: [],

			// COLORES
			ListaColores: [],

			// PROCESO 2 - LENTES TERMINADOS

			// ** SOLO UN PAR
			bndBlockLenteT: true,
			showTablaConfigLentes: false,
			ListaEsferasSelect: [],
			ListaEsferasxCilindrosLT: [],
			ListaCilindrosSelect: {
				Derecho: [],
				Izquierdo: [],
				Multiple: []
			},
			blockBtnCalculaLT: true,
			bndCalculoPrecioLT: false,

			// ** MAS DE UN PAR
			bndBlockInputsConfig: true,
			objTblLenteTerminado: {
				ValEsfera: '',
				ValCilindro: '',
				Cantidad: 0,
			},
			listaDetalleLT: [],

			// PROCESO 3 - LENTES DE CONTACTO

			listaDetalleLenteC: [],
			ListaColoresLenteC: [],
			ListaEjesLenteC: [
				{id:"",label:"Selecciona una opcion"}
			],
			ListaAdicionLenteC: [
				{id:"",label:"Selecciona una opcion"}
			],

			bndBlockLenteC: true,
			bndLentCUseColors: false,
			blockCilindro: false,
			blockEsfera: false,
			objTblLenteContacto: {
				IdArticuloWeb: 0,
				IdColor: 0,
				NombreColor: '',
				Color: '',
				Descripcion: '',
				Esfera: '',
				Cilindro: '',
				Eje: '',
				Adicion: '',
				Cantidad: 0,
			},

        }
    },
    methods :
    {	
		viewResumen() {

			let objTemp 				= this.objPedido;
			let objSubLinea				= this.ListaSublineas.filter(item => item.IdSubLinea == this.objPedido.IdSubLinea);
			let objMaterial				= this.ListaMateriales.filter(item => item.IdMaterial == this.objPedido.IdMaterial);
			let objProteccion			= this.ListaProtecciones.filter(item => item.IdProteccion == this.objPedido.IdProteccion);
			let objRecubrimiento		= this.ListaRecubrimientos.filter(item => item.IdRecubrimiento == this.objPedido.IdRecubrimiento);
			let objArmazon				= this.ListaArmazones.filter(item => item.IdArmazon == this.objPedido.IdArmazon);
			let objBisel				= this.ListaBiseles.filter(item => item.IdBisel == this.objPedido.IdBisel);
			let objColor				= this.ListaColores.filter(item => item.IdColor == this.objPedido.IdColor);
		


			objTemp.cliente 			= this.objCliente;
			objTemp.tipolente 			= this.TpLenteSelect;
			objTemp.articulo 			= this.articuloWebSelect;

			objTemp.sublinea 			= (objSubLinea != undefined && objSubLinea.length > 0) ? objSubLinea[0] : {Nombre: ''};
			objTemp.material 			= (objMaterial != undefined && objMaterial.length > 0) ? objMaterial[0] : {Nombre: ''};
			objTemp.proteccion 			= (objProteccion != undefined && objProteccion.length > 0) ? objProteccion[0] : {Nombre: ''};
			objTemp.recubrimiento 		= (objRecubrimiento != undefined && objRecubrimiento.length > 0) ? objRecubrimiento[0] : {Nombre: ''};
			objTemp.armazon 			= (objArmazon != undefined && objArmazon.length > 0) ? objArmazon[0] : {Nombre: ''};
			objTemp.bisel 				= (objBisel != undefined && objBisel.length > 0) ? objBisel[0] : {Nombre: ''};
			objTemp.color 				= (objColor != undefined && objColor.length > 0) ? objColor[0] : {Nombre: ''};

			objTemp.detallePedido 		= this.detallePedido;
			objTemp.detallepedidolt 	= this.listaDetalleLT;
			objTemp.detallepedidolc 	= this.listaDetalleLenteC;
			
           

			this.ConfigModalResumen.ModalTitle = 'Resumen de Pedido'; 
            this.bus.$emit('NewModal_'+EmitEjecuta2, objTemp);
		},

		validaGuardado() {

			let proceso = parseInt(this.TpLenteSelect.Proceso);
			let bndVerificacion = true;

			switch (proceso) {

				case 1:

					if(this.objPedido.IdArmazon == 0 || this.objPedido.IdArmazon == '' || this.objPedido.IdArmazon == null || this.objPedido.IdArmazon == undefined) {
						this.$toast.info('Se requiere selecciona un tipo de armazón'); 
						bndVerificacion = false; 
					}

					let countErros = 0;
					let banderas = {
						DBL: false,
						ED: false,
						B: false,
						A: false,
					};

					if(this.objPedido.DBL == '' || this.objPedido.DBL == '' || this.objPedido.DBL == null || this.objPedido.DBL == undefined) {
						countErros++;
						banderas.DBL = true;
					}

					if(this.objPedido.ED == '' || this.objPedido.ED == '' || this.objPedido.ED == null || this.objPedido.ED == undefined) {
						countErros++;
						banderas.ED = true;
					}

					if(this.objPedido.B == '' || this.objPedido.B == '' || this.objPedido.B == null || this.objPedido.B == undefined) {
						countErros++;
						banderas.B = true;
					}

					if(this.objPedido.A == '' || this.objPedido.A == '' || this.objPedido.A == null || this.objPedido.A == undefined) {
						countErros++;
						banderas.A = true;
					}


					if(countErros > 1) {
						this.$toast.warning('Se requiere completar las medidas del Armazón');
						bndVerificacion = false;

					}else {
						if(banderas.DBL) { this.$toast.info('Se requiere de un valor para DBL'); bndVerificacion = false; }
						if(banderas.ED) { this.$toast.info('Se requiere de un valor para ED'); bndVerificacion = false;  }
						if(banderas.B) { this.$toast.info('Se requiere de un valor para B'); bndVerificacion = false;  }
						if(banderas.A) { this.$toast.info('Se requiere de un valor para A'); bndVerificacion = false;  }
					}

					break;

				case 2:
					if (this.objPedido.NumPar == '') {
						bndVerificacion = false;
						this.$toast.warning('No has seleccionado una cantidad de pares de lentes');
					}	

					if(parseInt(this.objPedido.NumPar) == 1) {

						if(this.bndCalculoPrecioLT === false){
							this.$toast.info('Recalcule de nuevo para poder continuar');
							bndVerificacion = false;
						}

					}else if(parseInt(this.objPedido.NumPar) == 2) {
						if(this.listaDetalleLT.length == 0) {
							this.$toast.warning('No has agregado ningun elemento a tu pedido');
							bndVerificacion = false;
						}
						
					}

					
					break;
					
			}

			return bndVerificacion;
			
		},

		async Guardar(ptpSave = 'Cotizacion')
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			let Articulo = '';
			if(this.procesoActivo == 1) {
				Articulo = this.articuloWebSelect.Nombre;

			}else if(this.procesoActivo == 2) {
				if(this.NumPar = 1) {
					Articulo = this.articuloWebSelect.Nombre;
				}else {
					Articulo = 'LENTE TERMINADO'
				}

			}else if(this.procesoActivo == 3){
				Articulo = 'LENTE DE CONTACTO'
			}
			
			this.objPedido.Estatus 			= ptpSave;
			this.objPedido.detallePedido 	= this.detallePedido;
			this.objPedido.detallePedidoLT 	= this.listaDetalleLT;
			this.objPedido.detallePedidoLC 	= this.listaDetalleLenteC;
			this.objPedido.IdProceso		= this.procesoActivo;
			this.objPedido.EnviaArmazon 	= (this.objPedido.EnviaArmazon) ? 1 : 0;
			this.objPedido.ReqTinte 		= (this.objPedido.ReqTinte) ? 1 : 0;
			this.objPedido.CambioForma 		= (this.objPedido.CambioForma) ? 1 : 0;
			this.objPedido.UsaBiselSencillo = (this.objPedido.UsaBiselSencillo) ? 1 : 0;
			this.objPedido.IdArticuloWeb 	= (this.objPedido.NumPar == 2) ? 0 : this.objPedido.IdArticuloWeb;
			this.objPedido.Articulo			=  Articulo;
			//this.validaGuardado();

			let isSave = this.validaGuardado();
			if( isSave === true) {
				console.log('Guardando de funcion...');
		
				await this.$http.post(
					'pedidos', this.objPedido
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
				
			}else {
				if(parseInt(this.objPedido.IdPedido) == 0) {
					this.objPedido.Estatus = '';
				}
				
				this.oBtnSave.DisableBtn = false;
			}
			
        },

		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },

        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }

			if(parseInt(this.objPedido.IdPedido) == 0) {
				this.objPedido.Estatus = '';
			}
				
        },

		Recuperar()
        {
            this.$http.get(
                "pedidos/"+this.objPedido.IdPedido
            ).then((res) => {
                this.objPedido = res.data.data;
				this.objCliente  = this.objPedido.cliente;
				this.detallePedido = this.objPedido.detalle;
				this.mapLentesTerminados(this.objPedido.detallepedidolt);
				this.mapLentesContacto(this.objPedido.detallepedidolc);
				this.setCliente(this.objCliente);

				this.objPedido.EnviaArmazon = (parseInt(this.objPedido.EnviaArmazon) == 1) ? true : false;
				this.objPedido.ReqTinte = (parseInt(this.objPedido.ReqTinte) == 1) ? true : false;
				this.objPedido.CambioForma = (parseInt(this.objPedido.CambioForma) == 1) ? true : false;
				this.objPedido.UsaBiselSencillo = (parseInt(this.objPedido.UsaBiselSencillo) == 1) ? true : false;
				
				
				this.ConfigList.Title = '';
				if(this.objPedido.Estatus == 'Cotizacion') {
					this.ConfigList.Title = 'Cotizacion #'+this.objPedido.FolioCotizacion;
				}else {
					this.ConfigList.Title = 'Pedido #'+this.objPedido.FolioPedido;
				}

				this.selectorProceso(false,true);
				this.objPedido = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objPedido.Fecha.replace(/-/g,'\/');
                this.objPedido.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },

        Limpiar()
        {	
			console.log('limpiando General');
            this.objPedido = {
				IdPedido: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdSubLinea: 0,
				IdArticuloWeb: 0,
				IdMaterial: 0,
				IdProteccion: 0,
				IdRecubrimiento: 0,
				IdArmazon: 0,
				IdBisel: 0,
				IdTipoLente: 0,
				Estatus: '',
				FolioCotizacion: '',
				FolioPedido: '',
				Fecha: '',
				Paciente: '',

				OjoDerecho: true,
				OdEsfera: '',
				OdCilindro: '',
				OdEje: '',
				OdAdicion: '',
				OdPrisma: '',
				OdDnp: '',
				OdAltMon: '',
				OdAltSeg: '',
				OdPosicion: '',

				OjoIzquierdo: true,
				OiEsfera: '',
				OiCilindro: '',
				OiEje: '',
				OiAdicion: '',
				OiPrisma: '',
				OiDnp: '',
				OiAltMon: '',
				OiAltSeg: '',
				OiPosicion: '',

				ReqTinte: '',
				IdColor: 0,
				Color: '',
				Tono: '',
				Coloracion: '',
				NumPar: 0,
			
				UsaBiselSencillo: false,
				IdBiselSencillo: 0,
				IdSubBisel: 0, //'NINGUNO',
				NumGrapas: 0,

				Perforacion: '',
				
				ObservacionesGeneral: '',
				SubLinea: '',
				Articulo: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				Armazon: '',
				AnguloPantoscopico: '',
				AnguloPanoramico: '',
				DistanciaVertice: '',
				DistanciaLectura: '',
				Iniciales: '',
				AlturaSegmento: '',

				// PASO 3
				EnviaArmazon: false,
				MarcaArmazon: '',
				ColorArmazon: '',
				ModeloArmazon: '',
				EstadoArmazon: '',

				CambioForma: '',
				EscanearForma: '',
				MontarArmazon: '',
				AumentarArriba: '',
				AumentaAbajo: '',
				AumentaDerecho: '',
				Contorno: '',
				DBL: '',
				ED: '',
				B: '',
				A: '',
				AumentarMedida: 'NO',
				
				SubTotal: 0,
				Descuento: 0,
				Iva: 0,
				GranTotal: 0,
				FolioEnviado: '',
				Insertado: '',
				
            },
			this.detallePedido = [];
			this.listaDetalleLT = [];
			this.listaDetalleLenteC = [];
			this.detallePedidoLC = [];
			this.detallePedidoLT = [];
            this.errorvalidacion = [];
			this.objCliente = {
				Clave: '',
                NombreComercial: '',
                RazonSocial: '',
                Rfc: '',
                Contacto: '',
                Telefono: '',
                Correo: '',
                Direccion:'',
                Calle: '',
                NoInt: '',
                NoExt: '',
                Colonia: '',
                Cp: '',
                Cruzamiento1: '',
                Cruzamiento2: '',
                Referencias: '',
                IdEstado: '',
                IdMunicipio: '',
            }
			this.bndClienteReady = false;
			this.bndClientebyKey = false;
			this.bndClientebyName = false;

			this.TpLenteSelect = {
				IdTipoLente: 0,
				Nombre:"",
				Clave:"",
				Proceso:"0",
				Esfera:"NO",
				Cilindro:"NO",
				Eje:"NO",
				Adicion:"NO",
				AltMon:"NO",
				AltSeg:"NO",
				Dnp:"NO",
				Prisma:"NO",
				Posicion:"NO",
				ValMinMon:"0",
				ValMaxMon:"0",
				ValMinSeg:"0",
				ValMaxSeg:"0",
			},
			
			this.showNumParesLentes = false;
			this.limpiarConfLente(0);
			this.cambiarPaso(1);
        },

		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },

		cambiarPaso(tp, val = false){
			switch (tp) { // NUMERO DE PASO
				case 1:
					this.showPasos = {
						paso1: true,
						paso2: false,
						paso3: false, 
					};

					break;

				case 2:
					if( this.validaCambioPaso(2) == true ) {
						this.showPasos = {
							paso1: false,
							paso2: true,
							paso3: false, 
						};
						document.getElementById("lenteConfig").scrollIntoView(); // mueve el scroll a las opciones del RX
					}

					break;

				case 3:
					if( this.validaCambioPaso(3) == true) {
						this.showPasos = {
							paso1: false,
							paso2: false,
							paso3: true, 
						};

						document.getElementById("lenteConfig").scrollIntoView(); // mueve el scroll a las opciones del RX
					}
					
					break;
			
			}
		},

		validaCambioPaso (pPaso = 0) {
			
			switch (pPaso) {
				case 2:

					if(this.procesoActivo > 0) {

						if(this.procesoActivo == 1) {

							if( this.lentesSinSubLinea.includes(parseInt(this.TpLenteSelect.IdTipoLente)) ) {
								this.getArticulosWeb();
							}else {
								if(parseInt(this.objPedido.IdTipoLente) == 11){
									this.getArticulosWeb();
								}
							}
							
							if(this.objPedido.OjoDerecho == true) {

								// CAMPOS NO OBLIGATORIOS
								// VALIDAR SIEMPRE Y CUANDO EL CAMPO SE ENCUENTRE ACTIVO Y SEA DIFERENTE DE VACIO, 

								if(this.TpLenteSelect.Esfera == 'SI' && this.objPedido.OdEsfera != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;
								}

								if(this.TpLenteSelect.Cilindro == 'SI' && this.objPedido.OdCilindro != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;

									if(this.objPedido.OdEje == '') {
										this.toolTipRX.showToolOdEjeRequire = true;
										return false;
									}
								}
								
								// CAMPOS OBLIGATORIOS - CAMBIANTES
								// ** VALIDAREMOS CAMPOS CADA OJO SI SE ENCUENTRA ACTIVO 

								if(this.TpLenteSelect.Adicion == 'SI' && this.objPedido.OdAdicion == '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									this.RanAdicionalDerecho.showTool = true;
									return false;
								}

								// ALTURA DE MONTURA
								if(this.TpLenteSelect.AltMon == 'SI') { 
									if ( this.objPedido.OdAltMon == '' || this.objPedido.OdAltMon <= 0) {
										this.toolTipRX.showToolOdAltMon = true;
										return false;
									}
								}

								// DNP
								if(this.TpLenteSelect.Dnp == 'SI') {
									if(this.objPedido.OdDnp == '' || this.objPedido.OdDnp <= 0) {
										this.toolTipRX.showToolOdDnp = true;
										return false;
									}
								}							}

							if(this.objPedido.OjoIzquierdo == true) {

								// CAMPOS NO OBLIGATORIOS
								// VALIDAR SIEMPRE Y CUANDO EL CAMPO SE ENCUENTRE ACTIVO Y SEA DIFERENTE DE VACIO, 

								if(this.TpLenteSelect.Esfera == 'SI' && this.objPedido.OiEsfera != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;
								}

								if(this.TpLenteSelect.Cilindro == 'SI' && this.objPedido.OiCilindro != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;

									if(this.objPedido.OiEje == '') {
										this.toolTipRX.showToolOiEjeRequire = true;
										return false;
									}
								}


								// CAMPOS OPCIONALES
								// ** VALIDAREMOS CAMPOS CADA OJO SI SE ENCUENTRA ACTIVO 
								if(this.TpLenteSelect.Adicion == 'SI' && this.objPedido.OiAdicion == '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									this.RanAdicionalIzquierdo.showTool = true;
									return false;
								}

								// ALTURA DE MONTURA
								if(this.TpLenteSelect.AltMon == 'SI') { 
									if ( this.objPedido.OiAltMon == '' || this.objPedido.OiAltMon <= 0) {
										this.toolTipRX.showToolOiAltMon = true;
										return false;
									}
								}

								// DNP
								if(this.TpLenteSelect.Dnp == 'SI') {
									if(this.objPedido.OiDnp == '' || this.objPedido.OiDnp <= 0) {
										this.toolTipRX.showToolOiDnp = true;
										return false;
									}
								}
								
							}

							return true;
							

							
						}else if (this.procesoActivo == 2) {
							
							if(parseInt(this.objPedido.NumPar) == 0 || this.objPedido.NumPar == '' || this.objPedido.NumPar == undefined) {
								this.$toast.info('Requiere seleccionar la cantidad de lentes');
								return false;
							}
							
							return true;

						}else if (this.procesoActivo == 3) {
							if(this.showArticulos === false) {
								this.$toast.info('No se han podido cargar los productos');
								return false
							}

							return true;
						}
					}

					break;

				case 3:
					if(this.procesoActivo > 0) {

						if(this.procesoActivo == 1) {

							if(parseInt(this.objPedido.IdTipoLente) != 11) {
								if ( this.objPedido.IdSubLinea== '' || this.objPedido.IdSubLinea <= 0) {
									this.toolTipRX.showToolIdSubLinea = true;
									this.$toast.info('Requiere seleccionar una sublinea');
									return false;
								}
							}
							

							if( this.objPedido.IdArticuloWeb == '' ||  this.objPedido.IdArticuloWeb == 0) {
								this.toolTipRX.showToolIdArticuloWeb = true;
								this.$toast.info('Requiere seleccionar un articulo');
								return false;
							}

							if ( this.objPedido.IdMaterial== '' || this.objPedido.IdMaterial <= 0) {
								this.toolTipRX.showToolIdMaterial = true;
								this.$toast.info('Requiere seleccionar un material');
								return false;
							}

							if ( this.objPedido.IdRecubrimiento== '' || this.objPedido.IdRecubrimiento <= 0) {
								this.toolTipRX.showToolIdRecubrimiento = true;
								this.$toast.info('Requiere seleccionar un recubrimiento');
								return false;
							}

							if ( this.objPedido.IdProteccion== '' || this.objPedido.IdProteccion <= 0) {
								this.toolTipRX.showToolIdProteccion = true;
								this.$toast.info('Requiere seleccionar una protección');
								return false;
							}else {
								const result = this.detallePedido.filter((item) => item.TipoDet == 'Proteccion');
								if(result == undefined && result.length == 0) {
									this.$toast.info('Requiere seleccionar una protección');
								}
							}

							// SECCION DE CAMPOS VARIABLES SEGUN CONFIGURACION DE ARTICULO WEB
							let countErros = 0;
							let banderas = {
								AngPantos: false,
								AngPanoram: false,
								DistVertice: false,
								DistLectura: false,
								Iniciales: false,
								AlturaSegmento: false,
							};
							if( this.articuloWebSelect.AnguloPantoscopico == 'SI' ) {
								if (this.objPedido.AnguloPantoscopico == '') {
									this.toolTipRX.showToolAngPantos = true;
									countErros++;
									banderas.AngPantos = true;

								}else {
									this.validaRangosRX('AngPantos');
								}
							}

							if( this.articuloWebSelect.AnguloPanoramico == 'SI' ) {
								if (this.objPedido.AnguloPanoramico == '') {
									this.toolTipRX.showToolAngPanoram = true;
									countErros++;
									banderas.AngPanoram = true;
					
								}else {
									this.validaRangosRX('AngPanoram');
								}
							}
							
							if( this.articuloWebSelect.DistanciaVertice == 'SI' ) {
								if (this.objPedido.DistanciaVertice == '') {
									this.toolTipRX.showToolDistVertice = true;
									countErros++;
									banderas.DistVertice = true;
									
								}else {
									this.validaRangosRX('DistVertice');
								}
							}

							if( this.articuloWebSelect.DistanciaLectura == 'SI' ) {
								if (this.objPedido.DistanciaLectura == '') {
									this.toolTipRX.showToolDistLectura = true;
									countErros++;
									banderas.DistLectura = true;
									;
								}else {
									this.validaRangosRX('DistLectura');
								}
							}

							if(this.articuloWebSelect.Iniciales == 'SI'){
								if(this.objPedido.Iniciales == ''){
									this.toolTipRX.showToolIniciales = true;
									countErros++;
									banderas.Iniciales = true;
									
								}
							}

							if(this.TpLenteSelect.AltSeg == 'SI'){
								if(this.objPedido.AlturaSegmento == ''){
									this.toolTipRX.showToolAltSegSecundario = true;
									countErros++;
									banderas.AlturaSegmento = true;
									
								}
							}
							
							if(countErros > 1) {
								this.$toast.warning('Se requiere completar los campos');
								return false
							}else {
								if(banderas.AngPantos) { this.$toast.info('Se requiere de un valor para Angulo Pantoscopico'); return false }
								if(banderas.AngPanoram) { this.$toast.info('Se requiere de un valor para Angulo Panoramico'); return false  }
								if(banderas.DistVertice) { this.$toast.info('Se requiere de un valor para Distancia de Vertice'); return false  }
								if(banderas.DistLectura) { this.$toast.info('Se requiere de un valor para Distancia de Lectura'); return false  }
								if(banderas.Iniciales) { this.$toast.info('Se requiere de un valor para Iniciales'); return false  }
								if(banderas.AlturaSegmento) { this.$toast.info('Se requiere de un valor para Altura de Segmento'); return false  }
							}


							return true;

						}else if (this.procesoActivo == 2){

							// LLAMAMOS DE NUEVO EL VALIDADOR DE LA SECCION DE RX LENTES TERMINADOS
							let valid = this.desblockBtnLT();

							// SI ESTA ACTIVO EL OJO DERECHO Y LAS BANDERAN NO SON 3, FALTA UN DATO
							if(valid.ODerecho == true && valid.BndDerecho != 3) {
								this.$toast.info('Requiere completar los campo del Ojo Derecho');
								return false;
							}

							// SI ESTA ACTIVO EL OJO IZQUIERDO Y LAS BANDERAN NO SON 3, FALTA UN DATO
							if(valid.OIzquierdo == true && valid.BndIzquierdo != 3) {
								this.$toast.info('Requiere completar los campo del Ojo Izquierdo');
								return false;
							}

							if( this.bndCalculoPrecioLT == false ) {
								this.$toast.info('Recalcule de nuevo para poder continuar');
								return false;
							}

							return true;
						}

					}

					break;
			
				
			}
			
		},

		/***************** CLIENTE *****************/ 
		getClientebyClave() {
            console.log('executando cliente')
			if( this.objCliente.Clave != '') {
				this.$http.get('clientesbykey/'+this.objCliente.Clave)
				.then( res => {
					const cliente = res.data.data;
					//this.$refs.buscadorCliente.setArrClientes(cliente);
					this.objCliente = cliente;
					this.objPedido.IdCliente = cliente.IdCliente
					this.bndClientebyKey = true;
					this.bndClienteReady = true;

				}).catch( err => {
					this.$toast.warning('Cliente no encontrado');
					this.limpiaCliente();
					
				}).finally(() => {
					document.getElementById("lenteConfig").scrollIntoView(); // mueve el scroll al div de la tabla RX
				});
			}
            
        },

		getCliente() {
            console.log('executando cliente')
            this.$http.get( `/clientes/${this.objCliente.IdCliente}` )
            .then( res => {
                const cliente = res.data.data;
                this.objCliente = cliente;
				this.objPedido.IdCliente = cliente.IdCliente
                this.bndClienteReady = true;
                this.bndClientebyName = true;
				document.getElementById("lenteConfig").scrollIntoView(); // mueve el scroll al div de la tabla RX
            }).catch( err => {

            	this.limpiaCliente();
            });
        },

    	setCliente( cliente = {} ) {
			console.log('SettingCliente');
        	const buscadorCliente = this.$refs.buscadorCliente;
            buscadorCliente.clientes.push({
                label: `${cliente.Nombre}`,
                detalle: {
                    clave: cliente.Clave,
					Rfc: cliente.Rfc,
                },
				key: cliente.IdCliente,
        	});
			

        },

		limpiaCliente(){
            this.objCliente = {
                NombreComercial: '',
                RazonSocial: '',
                Rfc: '',
                Contacto: '',
                Telefono: '',
                Correo: '',
                Direccion:'',
                Calle: '',
                NoInt: '',
                NoExt: '',
                Colonia: '',
                Cp: '',
                Cruzamiento1: '',
                Cruzamiento2: '',
                Referencias: '',
                IdEstado: '',
                IdMunicipio: '',
            }
			this.bndClienteReady = false;
			this.bndClientebyKey = false;
			this.bndClientebyName = false;
        },

		/***************** TIPO LENTES *****************/ 
		getListTiposLentes()
		{
			this.$http.get("tiposlentes", {
				params:{
					isSimple: 1,
				}
			}).then((res) => {
				this.ListaTipoLentes = res.data.data;
			});
		},

		selectorProceso(pClean = true, pRecovery = false) {
		
			if(parseInt(this.objPedido.IdTipoLente) > 0) {
				let clean = pClean ? 1 :0;
				let array = this.ListaTipoLentes.filter(item => item.IdTipoLente == this.objPedido.IdTipoLente);

				if( array != undefined && array.length > 0 && parseInt(this.objCliente.IdCliente) > 0 ) {
					
					this.TpLenteSelect = array[0];
					switch (parseInt(this.TpLenteSelect.Proceso)) {
						case 1:
							console.log('Tipo Tabla Lente RX');
							this.limpiaRXDerecho(clean,clean);
							this.limpiaRXIzquierdo(clean,clean);
							this.showNumParesLentes 	= false;
							this.objPedido.NumPar 		= 0;

							this.objPedido.OjoDerecho 	= true;
							this.objPedido.OjoIzquierdo = true;
							this.showRXLentes 			= true;
							this.procesoActivo 			= 1;
		
							if( this.lentesSinSubLinea.includes(parseInt(this.TpLenteSelect.IdTipoLente)) ) {
								this.objPedido.IdSubLinea = 13;
								document.getElementById("confTablaRX").scrollIntoView(); // mueve el scroll a las opciones del RX
							}else {
								if( parseInt(this.TpLenteSelect.IdTipoLente) == 11){
									this.objPedido.IdSubLinea = 0;
								}else {
									this.getSublinea();
								}
								
							}

							if(pRecovery) {
								console.log('entro recovery select proceso')
								this.getArticulosWeb(true);
								//this.getMateriales ();
							}
							else
							{
								// SI TIENE CONFIGURACION POR DEFAULT Y NO ES RECOVERY ENTONCES SE COLOCA
								this.objPedido.OdAltSeg = this.TpLenteSelect.ValDefaultAltSeg;
								this.objPedido.OiAltSeg = this.TpLenteSelect.ValDefaultAltSeg;
							}

							this.getArmazones();
							this.getBiseles();
							this.getColoresTinte();
							
							break;

						case 2:
							// LIMPIAMOS Y APAGAMOS CONFIGURACIONES DE OTROS TIPOS
							console.log('Tipo Lente Terminado');
							
							this.objPedido.IdSubLinea 	= 0;
							this.procesoActivo 			= 2;
							this.showNumParesLentes 	= true;
							this.showRXLentes 			= false;
							
							if(pRecovery) {
								this.getArticulosWeb(true);
								this.viewLentesOrMateriales(true);

							}else {
								
								this.objPedido.OjoDerecho 	= false;
								this.objPedido.OjoIzquierdo = false;
								this.getArticulosWeb(false);
								this.limpiaRXDerecho(1,true);
								this.limpiaRXIzquierdo(1,true);
							}

							this.getArmazones();
							this.getBiseles();
							this.getColoresTinte();
							
							break;

						case 3:
							console.log('Tabla de obtrias para lentes de contacto');
							
							//this.limpiaRXDerecho(1,true);
							//this.limpiaRXIzquierdo(1,true);
							this.objPedido.OjoDerecho 	= false;
							this.objPedido.OjoIzquierdo = false;
							this.showRXLentes 			= false;
							this.showNumParesLentes 	= false;
							this.objPedido.NumPar 		= 2; // Se coloca por defecto 2, Multiple? 
							this.procesoActivo 			= 3;
							this.getArticulosWeb(pRecovery);
							
							
							
							break;

					}

				}else {
					if( this.objCliente.IdCliente == 0 ){
						this.$toast.info('Necesitas seleccionar un cliente');
						this.objPedido.IdTipoLente = 0;
						//this.showAlertCliente = true;
					}

					this.limpiaRXDerecho(1);
					this.limpiaRXIzquierdo(1);
					this.objPedido.OjoDerecho 	= false;
					this.objPedido.OjoIzquierdo = false;
					this.showRXLentes 			= false;
					this.showNumParesLentes 	= false;
					this.objPedido.NumPar 		= 0;
				}
			}else {
				this.limpiaRXDerecho(1);
				this.limpiaRXIzquierdo(1);
				this.objPedido.OjoDerecho 	= false;
				this.objPedido.OjoIzquierdo = false;
				this.showRXLentes 			= false;
				this.showNumParesLentes 	= false;
				this.objPedido.NumPar 		= 0;
			}
			
			
		},

		/***************** TABLA DE RX *****************/
		limpiaRXDerecho(op = 0, cleanDetalle = false) {
			if(this.objPedido.OjoDerecho == false || op > 0) {

				this.objPedido.OdEsfera		= '';
				this.objPedido.OdCilindro	= '';
				this.objPedido.OdEje 		= '';
				this.objPedido.OdAdicion	= '';
				this.objPedido.OdPrisma		= '';
				this.objPedido.OdDnp		= '';
				this.objPedido.OdAltMon		= '';
				this.objPedido.OdAltSeg		= '';
				this.objPedido.OdPosicion	= '';
				
				// PARA PROCESO 2 LENTES TERMINADOS
				this.bndCalculoPrecioLT = false;
				if (cleanDetalle) {
					const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');

					if(result != undefined) {
						this.detallePedido = result;
						this.calculaCostos();
					}
				}
				
			}
		},

		limpiaRXIzquierdo(op = 0, cleanDetalle = false) {
			if(this.objPedido.OjoIzquierdo == false || op > 0) {

				this.objPedido.OiEsfera		= '';
				this.objPedido.OiCilindro	= '';
				this.objPedido.OiEje 		= '';
				this.objPedido.OiAdicion	= '';
				this.objPedido.OiPrisma		= '';
				this.objPedido.OiDnp		= '';
				this.objPedido.OiAltMon		= '';
				this.objPedido.OiAltSeg		= '';
				this.objPedido.OiPosicion	= '';

				// PARA PROCESO 2 LENTES TERMINADOS
				this.bndCalculoPrecioLT = false;
				if (cleanDetalle) { 
					const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');

					if(result != undefined) {
						this.detallePedido = result;
						this.calculaCostos();
					}
				}
			}
				
		},

		limpiarConfLente(tp,pRecovery = false){

			switch (tp) {
				case 'sublinea':

					if(pRecovery === false)
					{
						this.objPedido.IdArticuloWeb 	= 0;
						this.objPedido.IdMaterial 		= 0;
						this.objPedido.IdProteccion 	= 0;
						this.objPedido.IdRecubrimiento 	= 0;

						this.articuloWebSelect = {
							IdArticuloWeb: 0,
							IdSublinea: 0,
							IdTipoLente: 0,
							Nombre: "",
							Clave: "",
							ReqTratExt: "NO",
							ReqTratamiento: "NO",
							AnguloPantoscopico: "NO",
							AnguloPanoramico: "NO",
							DistanciaVertice: "NO",
							DistanciaLectura: "NO",
							Iniciales: "NO",
							ReqTratInt: "NO",
							ReqEjeAdd: "NO",
							SolicitaListado: "",
							ViewSeccion: false,
							Seleccionable: true,
						};

						this.detallePedido = [];
					}

					this.bndBloqueoArticulo 			= false;
					this.toolTipRX.showPopArticulo 		= false;
					this.articuloWebSelect.ViewSeccion 	= false;
					this.calculaCostos();
					break;

				case 'articuloweb':

					if(pRecovery === false)
					{
						this.objPedido.IdMaterial 			= 0;
						this.objPedido.IdProteccion 		= 0;
						this.objPedido.IdRecubrimiento 		= 0;
						this.articuloWebSelect.ViewSeccion 	= false;
						this.objPedido.AlturaSegmento 		= '';
						this.objPedido.AnguloPantoscopico 	= '';
						this.objPedido.AnguloPanoramico 	= '';
						this.objPedido.DistanciaVertice 	= '';
						this.objPedido.DistanciaLectura 	= '';
						this.objPedido.Iniciales 			= '';
						this.detallePedido = [];
					}
					
			
					this.calculaCostos();
					break;

				case 'Material':

					if(pRecovery === false)
					{
						this.objPedido.IdProteccion 	= 0;
						this.objPedido.IdRecubrimiento 	= 0;
						this.detallePedido = [];
					}
					this.calculaCostos();

					break;

				case 'armazon':
					this.objPedido.EstadoArmazon 	= '';
					this.objPedido.MarcaArmazon 	= '';
					this.objPedido.ModeloArmazon 	= '';
					this.objPedido.ColorArmazon 	= '';
					//this.bndBloqueoProtxRecub 		= true;
					
					break;
				
				case 'biselsencillo':
					this.objPedido.UsaBiselSencillo = false;
					this.objPedido.IdBiselSencillo  = 0;

					break;

				case 'CambioForma':
					this.objPedido.EscanearForma 	= '';
					this.objPedido.MontarArmazon 	= '';
					this.objPedido.AumentarMedida 	= 'NO';	
					this.objPedido.AumentarArriba 	= '';
					this.objPedido.AumentaAbajo 	= '';
					this.objPedido.AumentaDerecho 	= '';
					this.objPedido.Contorno 		= '';
					
					break;
			
				default:
					//this.objPedido.IdSubLinea = (this.procesoActivo != undefined && this.procesoActivo == 2) ? 13 : 0;
					//this.objPedido.IdSubLinea 		= 13;
					this.objPedido.IdArticuloWeb 	= 0;
					this.objPedido.IdMaterial 		= 0;
					this.objPedido.IdProteccion 	= 0;
					this.objPedido.IdRecubrimiento 	= 0;

					this.articuloWebSelect = {
						IdArticuloWeb: 0,
						IdSublinea: 0,
						IdTipoLente: 0,
						Nombre: "",
						Clave: "",
						AnguloPantoscopico: "NO",
						AnguloPanoramico: "NO",
						DistanciaVertice: "NO",
						DistanciaLectura: "NO",
						Iniciales: "NO",
						ReqTratInt: "NO",
						ReqEjeAdd: "NO",
						ReqTratExt: "NO",
						ReqTratamiento: "NO",
						
						SolicitaListado: "",
						ViewSeccion: false,
						Seleccionable: true,
					};

					this.bndBloqueoArticulo 			= false;
					this.toolTipRX.showPopArticulo 		= false;
					this.articuloWebSelect.ViewSeccion 	= false;
					break;
			}
			
		},

		// EJECUTA LA BUSQUEDA POR API DE VALORES ESCRITOS EN LOS CAMPOS DE LA TABLA RX
		accionInput(id,tipo = ''){
			
			let signo = '';
			let valInicial = '';
			this.limpiarConfLente();

			switch (tipo) {
				case 'Esfera':	
					if(id == 'OdEsfera') {
						this.EsferaDerecha.showTool 	= false;
						this.EsferaDerecha.showPopOver 	= false;
						this.EsferaDerecha.listaMedidas = [];


						this.objPedido.OdEsfera = this.objPedido.OdEsfera.trim();
						signo 		= this.objPedido.OdEsfera.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OdEsfera.substring(1,this.objPedido.OdEsfera.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OdEsfera = '';
							this.EsferaDerecha.showTool = true;
							
						}
					}

					if(id == 'OiEsfera') {

						this.EsferaIzquierda.showTool 		= false;
						this.EsferaIzquierda.showPopOver 	= false;
						this.EsferaIzquierda.listaMedidas 	= [];

						this.objPedido.OiEsfera = this.objPedido.OiEsfera.trim();
						signo 		= this.objPedido.OiEsfera.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OiEsfera.substring(1,this.objPedido.OiEsfera.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}

						}else {
							valInicial 	=  '';
							this.objPedido.OiEsfera = '';
							this.EsferaIzquierda.showTool = true;
							
						}
					}

				break;

				case 'Cilindro':
					if(id == 'OdCilindro') {
						this.CilindroDerecho.showTool 		= false;
						this.CilindroDerecho.showPopOver 	= false;
						this.CilindroDerecho.listaMedidas 	= [];
						this.CilindroDerecho.blockEje 		= true;
						this.objPedido.OdEje 				= '';

						this.objPedido.OdCilindro = this.objPedido.OdCilindro.trim();
						signo 		= this.objPedido.OdCilindro.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OdCilindro.substring(1,this.objPedido.OdCilindro.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OdCilindro 		= '';
							this.CilindroDerecho.showTool 	= true;
							
						}
					}

					if(id == 'OiCilindro') {

						this.CilindroIzquierdo.showTool 		= false;
						this.CilindroIzquierdo.showPopOver 		= false;
						this.CilindroIzquierdo.listaMedidas 	= [];
						this.CilindroIzquierdo.blockEje 		= true;
						this.objPedido.OiEje 					= '';

						this.objPedido.OiCilindro = this.objPedido.OiCilindro.trim();
						signo 		= this.objPedido.OiCilindro.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OiCilindro.substring(1,this.objPedido.OiCilindro.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}

						}else {
							valInicial 	=  '';
							this.objPedido.OiCilindro = '';
							this.CilindroIzquierdo.showTool = true;
							
						}
					}
					break;

				case 'RangoAdicional':
					if(id == 'OdAdicion') {
						this.RanAdicionalDerecho.showTool 		= false;
						this.RanAdicionalDerecho.showPopOver 	= false;
						this.RanAdicionalDerecho.listaMedidas	= [];


						this.objPedido.OdAdicion = this.objPedido.OdAdicion.trim();
						signo 		= this.objPedido.OdAdicion.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OdAdicion.substring(1,this.objPedido.OdAdicion.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OdAdicion = '';
							this.RanAdicionalDerecho.showTool = true;
							
						}
					}

					if(id == 'OiAdicion') {
						this.RanAdicionalIzquierdo.showTool 	= false;
						this.RanAdicionalIzquierdo.showPopOver 	= false;
						this.RanAdicionalIzquierdo.listaMedidas = [];


						this.objPedido.OiAdicion = this.objPedido.OiAdicion.trim();
						signo 		= this.objPedido.OiAdicion.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OiAdicion.substring(1,this.objPedido.OiAdicion.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OiAdicion = '';
							this.RanAdicionalIzquierdo.showTool = true;
							
						}
					}

					break;

				case 'Eje':
					
					break;
				
			}

			//console.log('ValIni: '+valInicial);
			//console.log('Signo: '+signo);
			//console.log('tipo: '+tipo);

			if(valInicial !== '' && signo != '' && tipo != '') {

				this.$http.get("opgraduacionesrxs", {
					params:{
						Signo: signo,
						Tipo: tipo,
						ValorInicial: valInicial
					}
				}).then((res) => {
					console.log(res.data);

					switch (tipo) {
						case 'Esfera':
							if(id == 'OdEsfera') {
								this.EsferaDerecha.listaMedidas = res.data.data;
								this.EsferaDerecha.showPopOver = true;
							}

							if(id == 'OiEsfera') {
								this.EsferaIzquierda.listaMedidas = res.data.data;
								this.EsferaIzquierda.showPopOver = true;
							}

							break;

						case 'Cilindro':
							if(id == 'OdCilindro') {
								this.CilindroDerecho.listaMedidas = res.data.data;
								this.CilindroDerecho.showPopOver = true;
							}

							if(id == 'OiCilindro') {
								this.CilindroIzquierdo.listaMedidas = res.data.data;
								this.CilindroIzquierdo.showPopOver = true;
							}

							break;

						case 'RangoAdicional':
							if(id == 'OdAdicion') {
								this.RanAdicionalDerecho.listaMedidas = res.data.data;
								this.RanAdicionalDerecho.showPopOver = true;
							}

							if(id == 'OiAdicion') {
								this.RanAdicionalIzquierdo.listaMedidas = res.data.data;
								this.RanAdicionalIzquierdo.showPopOver = true;
							}

							break;
					}


				}).finally(()=>{
					
				});
			}
			
		},

		// VALIDA QUE LA ESCRITURA DE LOS RANGOS DE VALORES EN LA TABLA RX SEAN CORRECTOS
		validaRangosRX (tipo = '', id = '') {
			this.toolTipRX = {
				// EJE
				showToolOdEje: 			false,
				showToolOdEjeRequire: 	false,
				showToolOiEje: 			false,
				showToolOiEjeRequire: 	false,

				// ALT MONTURA
				showToolOdAltMon: 		false,
				showToolOiAltMon: 		false,

				// ALT SEGMENTO
				showToolOdAltSeg: 		false,
				showToolOiAltSeg: 		false,
				showToolAltSegSecundario:false,

				// DNP
				showToolOdDnp: 			false,
				showToolOiDnp: 			false,

				// PRISMA
				showToolOdPrisma: 		false,
				showToolOiPrisma: 		false,

				// SECCION DE PERSONALIZACION
				showToolAngPantos: 		false,
				showToolAngPanoram: 	false,
				showToolDistVertice: 	false,
				showToolDistLectura: 	false,
				showToolIniciales: 		false,

				showPopArticulo: 		false
			};
			
			switch (tipo) {
				case 'Esfera':
					if(id == 'OdEsfera') {
						console.log('ValidaRangosRX: ESFERA: '+this.objPedido.OdEsfera);
						this.getCheckValores(tipo,id,this.objPedido.OdEsfera); 
					}
					if(id == 'OiEsfera') {
						this.getCheckValores(tipo,id,this.objPedido.OiEsfera);
					}
					break;

				case 'Cilindro':
					if(id == 'OdCilindro') {
						this.getCheckValores(tipo,id,this.objPedido.OdCilindro);
					}
					if(id == 'OiCilindro') {
						this.getCheckValores(tipo,id,this.objPedido.OiCilindro);
					}
					break;

				case 'RangoAdicional':
					if(id == 'OdAdicion') {
						this.getCheckValores(tipo,id,this.objPedido.OdAdicion);
					}
					if(id == 'OiAdicion') {
						this.getCheckValores(tipo,id,this.objPedido.OiAdicion);
					}
					break;
				case 'Eje':
					if(id == 'OdEje') { 
						if (this.objPedido.OdEje < 0 || this.objPedido.OdEje > 180 ){
							this.objPedido.OdEje = '';
							this.toolTipRX.showToolOdEje = true;
						}
					}
					if(id == 'OiEje') { 
						if (this.objPedido.OiEje < 0 || this.objPedido.OiEje > 180 ){
							this.objPedido.OiEje = '';
							this.toolTipRX.showToolOiEje = true;
						}
					}
					break;

				case 'AltMont':
					if(id == 'OdAltMon') { 
					
						if (parseInt(this.objPedido.OdAltMon) < parseInt(this.TpLenteSelect.ValMinMon) || this.objPedido.OdAltMon > parseInt(this.TpLenteSelect.ValMaxMon) ) {
							this.objPedido.OdAltMon = '';
							this.toolTipRX.showToolOdAltMon = true;

							return false;
						}
						return true;
					}
					if(id == 'OiAltMon') { 
						if (parseInt(this.objPedido.OiAltMon) < parseInt(this.TpLenteSelect.ValMinMon) || this.objPedido.OiAltMon > parseInt(this.TpLenteSelect.ValMaxMon) ) {
							this.objPedido.OiAltMon = '';
							this.toolTipRX.showToolOiAltMon = true;
						}
					}
					break;
				
				case 'AltSeg':
					// FIX: QUEDA INUTILIZADO TRAS MENCION DE QUE SERA UN DATO UNICO PARA EL ARTICULO Y NO UN PARAMETRO POR CADA OJO EN EL RX
					if(id == 'OdAltSeg') { 
						if (parseInt(this.objPedido.OdAltSeg) < parseInt(this.TpLenteSelect.ValMinSeg) || this.objPedido.OdAltSeg > parseInt(this.TpLenteSelect.ValMaxSeg) ) {
							this.objPedido.OdAltSeg = '';
							this.toolTipRX.showToolOdAltSeg = true;
						}
					}
					if(id == 'OiAltSeg') { 
						if (parseInt(this.objPedido.OiAltSeg) < parseInt(this.TpLenteSelect.ValMinSeg) || this.objPedido.OiAltSeg > parseInt(this.TpLenteSelect.ValMaxSeg) ) {
							this.objPedido.OiAltSeg = '';
							this.toolTipRX.showToolOiAltSeg = true;
						}
					}
					break;

				case 'Dnp':
					if(id == 'OdDnp') { 
						if (this.objPedido.OdDnp < 20 || this.objPedido.OdDnp > 50 ) {
							this.objPedido.OdDnp = '';
							this.toolTipRX.showToolOdDnp = true;
						}
					}
					if(id == 'OiDnp') { 
						if (this.objPedido.OiDnp < 20 || this.objPedido.OiDnp > 50 ) {
							this.objPedido.OiDnp = '';
							this.toolTipRX.showToolOiDnp = true;
						}
					}
					break;

				case 'Prisma':
					if(id == 'OdPrisma') { 
						if (this.objPedido.OdPrisma < 0 || this.objPedido.OdPrisma > 15 ) {
							this.objPedido.OdPrisma = '';
							this.toolTipRX.showToolOdPrisma = true;
						}
					}
					if(id == 'OiPrisma') { 
						if (this.objPedido.OiPrisma < 0 || this.objPedido.OiPrisma > 15 ) {
							this.objPedido.OiPrisma = '';
							this.toolTipRX.showToolOiPrisma = true;
						}
					}
					break;
				
				case 'AngPantos':
					if (this.objPedido.AnguloPantoscopico < 0 || this.objPedido.AnguloPantoscopico > 20 ) {
						this.objPedido.AnguloPantoscopico = '';
						this.toolTipRX.showToolAngPantos = true;
					}
					break;

				case 'AngPanoram':
					if (this.objPedido.AnguloPanoramico < 0 || this.objPedido.AnguloPanoramico > 20 ) {
						this.objPedido.AnguloPanoramico = '';
						this.toolTipRX.showToolAngPanoram = true;
					}
					break;

				case 'DistVertice':
					if (this.objPedido.DistanciaVertice < 0 || this.objPedido.DistanciaVertice > 40 ) {
						this.objPedido.DistanciaVertice = '';
						this.toolTipRX.showToolDistVertice = true;
					}
					break;

				case 'DistLectura':
					if (this.objPedido.DistanciaLectura < 0 || this.objPedido.DistanciaLectura > 40 ) {
						this.objPedido.DistanciaLectura = '';
						this.toolTipRX.showToolDistLectura = true;
					}
					break;
				
				case 'AltSegmento':
					console.log(this.TpLenteSelect.ValMinSeg);
					console.log(this.TpLenteSelect.ValMaxSeg);
					if (parseInt(this.objPedido.AlturaSegmento) < 13 ) {
						
						this.objPedido.AlturaSegmento = '';
						this.toolTipRX.showToolAltSegSecundario = true;
					}
					break;
			
			}
		},

		getCheckValores(tipo = '', id = '' ,valInicial = '') {
			console.log('getCheckValores: valor: '+valInicial+' tipo: '+tipo,' id:'+id);
			if(valInicial !== '' && tipo != '' && id != '') {
				if(valInicial !='+' && valInicial !='-')
				{

				this.$http.get("opvalidagraduacionesrxs", {
					params:{
						Tipo: tipo,
						Valor: valInicial
					}
				}).then((res) => {
					console.log(res.data.eCode);
					if(res.data.eCode == 1001) {
					console.log('entro a valid')
						this.setValor(res.data.data.Valor,tipo,id);
						this.onClose(id,tipo);

					}else if(res.data.eCode == 1002) {
						this.onClose(id,tipo);
						switch (tipo) {
							case 'Esfera':
								if(id == 'OdEsfera') {
									this.objPedido.OdEsfera = '';
									this.EsferaDerecha.showPopOver = true;
									
								}

								if(id == 'OiEsfera') {
									this.objPedido.OiEsfera = '';
									this.EsferaIzquierda.showPopOver = true;
								}

								break;

							case 'Cilindro':
								if(id == 'OdCilindro') {
									this.objPedido.OdCilindro = '';
									this.CilindroDerecho.showPopOver = true;
								}

								if(id == 'OiCilindro') {
									this.objPedido.OiCilindro = '';
									this.CilindroIzquierdo.showPopOver = true;
								}

								break;

							case 'RangoAdicional':
								if(id == 'OdAdicion') {
									this.objPedido.OdAdicion = '';
									this.RanAdicionalDerecho.showPopOver = true;
								}

								if(id == 'OiAdicion') {
									this.objPedido.OiAdicion = '';
									this.RanAdicionalIzquierdo.showPopOver = true;
								}

								break;
						}
						this.$toast.info('Introduce un valor correcto');
					}


				}).finally(()=>{
					
				});
				}
			}else{
				console.log('CheckFail');
			}
		},

		// FUNCION ENCARGADA DE CARGAR EL VALOR A LA VARIABLE CORRESPONDIENTE BASADA EN LA SELECCION DEL USUARIO EN EL POOPOVER
		setValor(valor = '', tipo = '', id = '') {
			
			console.log('setValor: valor: '+valor+' tipo: '+tipo,' id:'+id);

			switch (tipo) {

				case 'Esfera':

					if(id == 'OdEsfera') {
						this.EsferaDerecha.showTool 	= false;
						this.EsferaDerecha.showPopOver 	= false;
						
						this.objPedido.OdEsfera = '';
						this.objPedido.OdEsfera = valor.trim();
					}

					if(id == 'OiEsfera') {

						this.EsferaIzquierda.showTool 		= false;
						this.EsferaIzquierda.showPopOver 	= false;
						
						this.objPedido.OiEsfera = '';
						this.objPedido.OiEsfera = valor.trim();
					}

				break;

				case 'Cilindro':
				
					if(id == 'OdCilindro') {
						this.CilindroDerecho.showTool 		= false;
						this.CilindroDerecho.showPopOver 	= false;
						
						this.objPedido.OdCilindro 			= '';
						this.objPedido.OdCilindro			= valor;
						this.CilindroDerecho.blockEje 		= false;
					}

					if(id == 'OiCilindro') {
						this.CilindroIzquierdo.showTool 	= false;
						this.CilindroIzquierdo.showPopOver 	= false;
						
						this.objPedido.OiCilindro 			= '';
						this.objPedido.OiCilindro 			= valor;
						this.CilindroIzquierdo.blockEje 	= false;
					}

				break;

				case 'RangoAdicional':

					if(id == 'OdAdicion') {
						this.RanAdicionalDerecho.showTool 		= false;
						this.RanAdicionalDerecho.showPopOver 	= false;
						
						this.objPedido.OdAdicion = '';
						this.objPedido.OdAdicion = valor.trim();
						this.copiaAdicion(valor.trim(), id);
					}

					if(id == 'OiAdicion') {
						this.RanAdicionalIzquierdo.showTool 	= false;
						this.RanAdicionalIzquierdo.showPopOver 	= false;
						
						this.objPedido.OiAdicion = '';
						this.objPedido.OiAdicion = valor.trim();
						this.copiaAdicion(valor.trim(), id);
					}

				break;
			}
		},

		copiaAdicion(pValor = '', id = '') {
			
			// SI SE RECIBE ID LADO DERECHO, VERIFICAMOS SI PODEMOS COPIAR AL IZQUIERDO
			if( id == 'OdAdicion' ) {
				if(pValor !='') {
					if(this.objPedido.OiAdicion == '') {
						this.objPedido.OiAdicion = pValor;
					}
				}
			}

			// SI SE RECIBE ID LADO IZQUIERDO, VERIFICAMOS SI PODEMOS COPIAR AL DERECHO
			if (id == 'OiAdicion' ) {
				if( pValor != '' ) {
					
					if(this.objPedido.OdAdicion == ''){
						this.objPedido.OdAdicion = pValor;
					}
				}
			}
		},

		onClose(id,tipo) {
			switch (tipo) {
				case 'Esfera':	
					if(id == 'OdEsfera') { this.EsferaDerecha.showPopOver 	= false; }
					if(id == 'OiEsfera') { this.EsferaIzquierda.showPopOver = false; }
					
					break;

				case 'Cilindro':	
					if(id == 'OdCilindro') { this.CilindroDerecho.showPopOver 	= false; }
					if(id == 'OiCilindro') { this.CilindroIzquierdo.showPopOver 	= false; }
					
					break;

				case 'RangoAdicional':	
					if(id == 'OdAdicion') { this.RanAdicionalDerecho.showPopOver 	= false; }
					if(id == 'OiAdicion') { this.RanAdicionalIzquierdo.showPopOver 	= false; }
					
					break;

				case 'Eje':	
					if(id == 'OdEje') { this.RanAdicionalDerecho.showPopOver 	= false; }
					if(id == 'OiEje') { this.RanAdicionalIzquierdo.showPopOver 	= false; }
					
					break;
			}
		},

		onHidden() {
			/****** CONTROL DE ESFERAS ******/
			this.EsferaDerecha ={
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			this.EsferaIzquierda ={
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			/****** CONTROL DE CILINDROS ******/
			this.CilindroDerecho.showTool 		= false;
			this.CilindroDerecho.showPopOver 	= false;
			this.CilindroDerecho.listaMedidas 	= [];

			this.CilindroIzquierdo.showTool 	= false;
			this.CilindroIzquierdo.showPopOver 	= false;
			this.CilindroIzquierdo.listaMedidas = [];


			/****** CONTROL DE RANGOS ADICIONALES ******/
			this.RanAdicionalDerecho = {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},
			this.RanAdicionalIzquierdo = {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			console.log('Accion al cerrar el pophover');
		},

		/***************** SELECCION DE SUBLINEAS PARA LENTES PROGRESIVOS *****************/

		// OBTIENE POR API LOS ARTICULOS DE SUBLINEA
		getSublinea() {
			console.log('Obteniendo Sub-lineas');

			this.ListaSublineas = [];
			this.$http.get( '/oplentesublineas',{
				params:{
					IdTipoLente: this.TpLenteSelect.IdTipoLente,
				}
			} )
            .then( res => {
				this.ListaSublineas = res.data.data;

            }).catch( err => {
				console.log(err);
            }).finally(() => {
				document.getElementById("confTablaRX").scrollIntoView(); // mueve el scroll a las opciones del RX
			});
		},

		/***************** SELECCION DE ARTICULOS WEB *****************/

		// OBTIENE POR API LOS ARTICULOS DE SUBLINEA
		getArticulosWeb( pRecovery = false) {
			console.log('Obteniendo Articulos Web');
			this.limpiarConfLente('sublinea',pRecovery)
			this.ListaArticulosWeb = [];
			let newRequest = {
					IdSubLinea: this.objPedido.IdSubLinea,
					TipoLente: this.TpLenteSelect,
					OdEsfera: this.objPedido.OdEsfera,
					OiEsfera: this.objPedido.OiEsfera,
					OdCilindro: this.objPedido.OdCilindro,
					OiCilindro: this.objPedido.OiCilindro,
					OdAdicion: this.objPedido.OdAdicion,
					OiAdicion: this.objPedido.OiAdicion,
			};

			this.$http.post('/opgetarticulosweb', newRequest)
            .then( res => {
				this.ListaArticulosWeb = res.data.data;
				this.showArticulos = true;

            }).catch( err => {
				console.log(err);
            }).finally(() => {
				if(this.procesoActivo == 1) {
					if(pRecovery === false) {
						document.getElementById("articulosrx").scrollIntoView(); // mueve el scroll a las opciones del RX
					}
					
					this.getMateriales(pRecovery);

				}else if(this.procesoActivo == 2 && pRecovery) {
					this.getEsferasxCilindrosLentes(pRecovery);
				}
			});
		},

		// OBTIENE POR API LOS MATERIALES DE DISPONIBLES Y ESTABLECE GLOBAL EN EL FORM EL ARTICULO WEB SELECCIONADO
		getMateriales (pRecovery = false) {
			console.log('Obteniendo Materiales');
			// BUSCAMOS Y ESTABLECEMOS EL ARTICULO WEB DE MANERA GLOBAL EN EL FORM
				console.log('si entro a '+this.objPedido.IdArticuloWeb)
			if(parseInt(this.objPedido.IdArticuloWeb) > 0) {
				let array = this.ListaArticulosWeb.filter(item => item.IdArticuloWeb == this.objPedido.IdArticuloWeb);
				this.limpiarConfLente('articuloweb',pRecovery);
				this.articuloWebSelect.ViewSeccion = false;

				if(array != undefined && array.length > 0) {
					this.articuloWebSelect = array[0];

					// SE VERIFICA QUE EL ARTICULO SELECCIONADO SI ESTA DISPONIBLE PARA CONTINUAR CON EL PROCESO. 
					if(this.articuloWebSelect.Seleccionable == 'NO') {
						this.bndBloqueoArticulo 			= true;
						this.toolTipRX.showPopArticulo 		= true;
						this.articuloWebSelect.ViewSeccion 	= false;

					}else {
						this.bndBloqueoArticulo 			= false;
						this.toolTipRX.showPopArticulo 		= false;
						this.articuloWebSelect.ViewSeccion 	= false;

						if(this.articuloWebSelect.AnguloPantoscopico == 'SI' || this.articuloWebSelect.AnguloPanoramico == 'SI' || this.articuloWebSelect.DistanciaLectura == 'SI' || this.articuloWebSelect.DistanciaVertice == 'SI' || this.articuloWebSelect.Iniciales == 'SI' || this.articuloWebSelect.ReqAltSeg ){
							this.articuloWebSelect.ViewSeccion = true;
						}else {
							this.articuloWebSelect.ViewSeccion = false;
						}
					}

				}else {
					this.bndBloqueoArticulo 			= false;
					this.toolTipRX.showPopArticulo 		= false;
					this.articuloWebSelect.ViewSeccion 	= false;
				}


				// LLAMADO DE API
				this.ListaMateriales = [];
				let newRequest = {
					ArticuloWeb: this.articuloWebSelect,

					OdEsfera: this.objPedido.OdEsfera,
					OiEsfera: this.objPedido.OiEsfera,

					OdCilindro: this.objPedido.OdCilindro,
					OiCilindro: this.objPedido.OiCilindro,

					OdAdicion: this.objPedido.OdAdicion,
					OiAdicion: this.objPedido.OiAdicion,
				};

				this.$http.post('/opgetmateriales', newRequest)
				.then( res => {
					console.log(res.data);
					this.ListaMateriales = res.data.data;

				}).catch( err => {
					console.log(err);
				}).finally( () => {
					if(pRecovery === false) {
						if(this.articuloWebSelect.ViewSeccion = true) {
							document.getElementById("ParamPersonalizacion").scrollIntoView(); // mueve el scroll a las opciones del RX 
						}else {
							document.getElementById("materialesrx").scrollIntoView(); // mueve el scroll a las opciones del RX 
						}

					}
					this.getValidMaterialSelected(pRecovery);
				})

			}else {
				this.bndBloqueoArticulo = false;
				this.articuloWebSelect.ViewSeccion = false;
			}

		},


		getValidMaterialSelected(pRecovery = false) {
			if(parseInt(this.objPedido.IdMaterial) > 0) {
				let array = this.ListaMateriales.filter(item => item.IdMaterial == this.objPedido.IdMaterial);

				if(array != undefined) {
					this.materialSelect = array[0];

					// SE VERIFICA QUE EL ARTICULO SELECCIONADO SI ESTA DISPONIBLE PARA CONTINUAR CON EL PROCESO. 
					if(this.materialSelect.Seleccionable == 'NO') {
						this.bndBloqueoMaterial			= true;
						this.toolTipRX.showPopMaterial 	= true;
						this.bndBloqueoProtxRecub		= true;

					}else {
						this.bndBloqueoMaterial 		= false;
						this.toolTipRX.showPopMaterial 	= false;
						this.bndBloqueoProtxRecub		= false;

						this.limpiarConfLente('Material',pRecovery)
						this.getProtecciones(pRecovery);
						this.getRecubrimientos(pRecovery);

					}

				}else {
					this.bndBloqueoProtxRecub			= true;
					this.bndBloqueoMaterial 			= false;
					this.toolTipRX.showPopMaterial 		= false;
				}

				
			}
		},

		// OBTIENE POR API LAS PROTECCIONES DISPONIBLES PARA EL ARTICULO WEB
		getProtecciones(pRecovery = false) {
			console.log('Obteniendo Protecciones');

			if(parseInt(this.objPedido.IdMaterial) > 0) {

				this.ListaProtecciones = [];
				let newRequest = {
						ArticuloWeb: this.articuloWebSelect,
						IdMaterial: this.objPedido.IdMaterial,

						OdEsfera: this.objPedido.OdEsfera,
						OiEsfera: this.objPedido.OiEsfera,
						OdCilindro: this.objPedido.OdCilindro,
						OiCilindro: this.objPedido.OiCilindro,
						OdAdicion: this.objPedido.OdAdicion,
						OiAdicion: this.objPedido.OiAdicion,
				};

				this.$http.post('/opgetprotecciones', newRequest)
				.then( res => {
					this.ListaProtecciones = res.data.data;
					this.showProteccion = true;

				}).catch( err => {
					console.log(err);
				}).finally( () => {

					if(pRecovery == false) {
						document.getElementById("proteccionesrx").scrollIntoView(); // mueve el scroll a las opciones del RX 
						this.calculaDioptrias();
					}

				});
			}
		},

		/***************** SECCION CALCULO DE DIOPTRIAS *****************/
		calculaDioptrias() {
			let newRequest = {
				//ArticuloWeb: this.articuloWebSelect,
				Procedimiento: 'Dioptria',
				IdMaterial: this.objPedido.IdMaterial,
				IdCliente: this.objCliente.IdCliente,

				OdEsfera: this.objPedido.OdEsfera,
				OiEsfera: this.objPedido.OiEsfera,
				OdCilindro: this.objPedido.OdCilindro,
				OiCilindro: this.objPedido.OiCilindro,
				//OdAdicion: this.objPedido.OdAdicion,
				//OiAdicion: this.objPedido.OiAdicion,
			};

			const result = this.detallePedido.filter((item) => item.TipoDet != 'Dioptria');
			this.detallePedido = result;
			this.$http.post('/opgetcostos', newRequest)
			.then( res => {
				console.log(res.data.data);
				if( res.data.data != undefined && res.data.data != '') {
					this.detallePedido.push(res.data.data);
				}
				this.calculaCostos();

			}).catch( err => {
				console.log(err);
			}).finally(() => {
				
			})
		},

		/***************** SECCION CALCULO DE COSTO PROTECCIONES *****************/
		calculaCostosProtecciones() {
			let newRequest = {
				
				Procedimiento: 'Proteccion',
				ArticuloWeb: this.articuloWebSelect,
				TipoLente: this.TpLenteSelect,
				IdCliente: this.objCliente.IdCliente,
				IdMaterial: this.objPedido.IdMaterial,
				IdSubLinea: this.objPedido.IdSubLinea,
				IdProteccion:this.objPedido.IdProteccion,
				OjoDerecho: (this.objPedido.OjoDerecho == true) ? 'SI' : 'NO',
				OjoIzquierdo: (this.objPedido.OjoIzquierdo == true) ? 'SI' : 'NO',
				
				//SECCION PARA LENTES TERMINADOS
				NumPares: this.objPedido.NumPar,
				CantidadTotal: this.objTblLenteTerminado.CantidadTotal
				
			};

			const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');
			this.detallePedido = result;

			this.$http.post('/opgetcostos', newRequest)
			.then( res => {
				this.detallePedido.unshift(res.data.data);
				this.calculaCostos();


				if(this.procesoActivo == 2) {
					// INDICA QUE YA SE HA REALIZADO UN CALCULO DE COSTOS
					this.bndCalculoPrecioLT = true;
				}

			}).catch( err => {
				console.log(err);
				this.$toast.error('Esta Proteccion no esta disponible');
				this.objPedido.IdProteccion = 0;
			}).finally(() => {
				
			})
		},


		// OBTIENE POR API LOS RECUBRIMIENTOS DISPONIBLES PARA EL ARTICULO WEB
		getRecubrimientos() {
			console.log('Obteniendo Recubrimientos');

			if(parseInt(this.objPedido.IdMaterial) > 0) {

				this.ListaRecubrimientos = [];
				let newRequest = {
					ArticuloWeb: this.articuloWebSelect,
				};

				this.$http.post('/opgetrecubrimientos', newRequest)
				.then( res => {
					this.ListaRecubrimientos = res.data.data;
					this.showRecubrimiento = true;

				}).catch( err => {
					console.log(err);
				});
			}
		},

		/***************** SECCION CALCULO DE COSTO RECUBRIMIENTO *****************/
		calculaCostosRecubrimiento() {
			let newRequest = {
				
				Procedimiento: 'Recubrimiento',
				ArticuloWeb: this.articuloWebSelect,
				IdCliente: this.objCliente.IdCliente,
				IdRecubrimiento: this.objPedido.IdRecubrimiento,
				
			};

			if(parseInt(this.objPedido.IdMaterial) > 0 && parseInt(this.objPedido.IdRecubrimiento) > 0) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Recubrimiento');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
					this.$toast.error('Esta opcion de recubrimiento no esta disponible');
					this.objPedido.IdRecubrimiento = 0;
				}).finally(() => {
					
				})
			}
		},

		/***************** SECCION DE MANEJO DE COSTOS *****************/
		calculaCostos() {
			console.log('Haciendo calculos: '+new Date());
			
			let subtotal = 0;
			let descuentos = 0;
			this.detallePedido.forEach((item) => {
				subtotal += parseFloat(item.Importe);
				descuentos += parseFloat(item.PrecioDesc);
			});
			

			this.objPedido.SubTotal 	= subtotal;
			this.objPedido.Descuento 	= descuentos;
			this.objPedido.Iva 			= (subtotal*0.16);
			this.objPedido.GranTotal 	= (subtotal + this.objPedido.Iva);
		},

		// OBTIENE POR API LOS ARMAZONES DISPONIBLES PARA EL ARTICULO WEB
		getArmazones() {
			console.log('Obteniendo Armazones');			

			this.ListaArmazones = [];

			this.$http.get('/opgetarmazon')
			.then( res => {
				this.ListaArmazones = res.data.data;

			}).catch( err => {
				console.log(err);
			});
			
		},

		// OBTIENE POR API LOS BISELES DISPONIBLES PARA EL ARTICULO WEB
		getBiseles() {
			console.log('Obteniendo Armazones');			

			this.ListaBiseles = [];

			this.$http.get('/opgetbiseles')
			.then( res => {
				this.ListaBiseles = res.data.data.map(item => 
				({
					IdBisel: item.IdBisel,
					Nombre: item.Nombre,
					Clave: item.Clave,
            		SubRegistro: item.SubRegistro,
            		ReqArmazon: item.ReqArmazon,
					Disponible: 'NO',
				})
			);

			}).catch( err => {
				console.log(err);
			});
			
		},

		getBiselesFilter(pTP = ''){
			return this.ListaBiseles.filter( item => item.ReqArmazon == pTP);
		},

		setBiselesActivos(pNuevo = false) {

			// SET PARA ACCION DIRECTA DEL BOTON SWITCH
			if(pNuevo) {
				this.objPedido.EstadoArmazon = 'Nuevo';
			}
			
			// UBICAR EL ARMAZON QUE SE HA SELECCIONADO
			let pBisel =  this.ListaArmazones.filter( item => item.IdArmazon == this.objPedido.IdArmazon);
			console.log(pBisel);
			
			if (pBisel.length != null && pBisel.length > 0) { 

				// SE OBTIENE EL BISEL ANIDADO AL ARMAZON SELECCIONADO
				this.ListaBiseles.forEach((item) => {

					if(item.IdBisel == pBisel[0].IdBisel){
						item.Disponible = 'SI';
						this.objPedido.IdBisel = item.IdBisel;
						this.calculaCostoBisel();
					}else {
						item.Disponible = 'NO';
					}
				});	
			}

			// TODO: - VERIFICAR FUNCIONCIONALIDAD
			if( this.objPedido.EnviaArmazon == false) {

				// SI SE ENCONTRABA ACTIVO EL USO DE BISEL SENCILLO, SE LIMPIA IGUALMENTE EL ELEMENTO
				if( this.objPedido.UsaBiselSencillo == true ) {
					const result = this.detallePedido.filter((item) => item.TipoDet != 'BiselSencillo');
					this.detallePedido = result;

					this.limpiarConfLente('biselsencillo');
				}

				// LIMPIAMOS DETALLE DE REGISTROS DE BISEL
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Bisel');
				this.detallePedido = result;

	
				this.calculaCostos();

				//LIMPIAMOS LOS CAMPOS CORRESPONDIENTES AL ARMAZON
				this.limpiarConfLente('armazon');

				if ( this.objPedido.NumPar == 1 ) {
					this.objPedido.CambioForma 	= false;
					this.objPedido.IdArmazon 	= 0;
					this.objPedido.ED 			= '';
					this.objPedido.DBL 			= '';
					this.objPedido.B 			= '';
					this.objPedido.A 			= '';
					this.calculaCostoForma();
				}
			}
		},

		calculaCostoBisel() {
			let newRequest = {
				Procedimiento: 'Bisel',
				IdCliente: this.objCliente.IdCliente,
				IdBisel: this.objPedido.IdBisel,
			};

			if( this.objPedido.EnviaArmazon == true && this.objPedido.IdBisel > 0) {

				const result = this.detallePedido.filter((item) => item.TipoDet != 'Bisel');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
					this.$toast.error('Este Bisel no esta disponible');
					this.objPedido.IdBisel = 0;
				}).finally(() => {
					
				});

			}

		},

		calculaCostoBiselSencillo(pIdBiselSencillo) {
			
			if( this.objPedido.EnviaArmazon == true ) {

				if( this.objPedido.UsaBiselSencillo == true ) {

					this.objPedido.IdBiselSencillo = (pIdBiselSencillo != '' && pIdBiselSencillo > 0) ? pIdBiselSencillo : 0;

					let newRequest = {
						Procedimiento: 'BiselSencillo',
						IdCliente: this.objCliente.IdCliente,
						IdBiselSencillo: this.objPedido.IdBiselSencillo
					};

					const result = this.detallePedido.filter((item) => item.TipoDet != 'BiselSencillo');
					this.detallePedido = result;

					this.$http.post('/opgetcostos', newRequest)
					.then( res => {
						console.log(res.data);
						this.detallePedido.push(res.data.data);
						this.calculaCostos();

					}).catch( err => {
						console.log(err);
					}).finally(() => {
						
					});

				}else {
					const result = this.detallePedido.filter((item) => item.TipoDet != 'BiselSencillo');
					this.detallePedido = result;
					this.calculaCostos();
				}

			}

		},

		calculaCostoForma() {
			let newRequest = {
				
				Procedimiento: 'CambioForma',
				IdCliente: this.objCliente.IdCliente,
				//IdRecubrimiento: this.objPedido.IdRecubrimiento,
				
			};

			if( this.objPedido.CambioForma == true ) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'CambioForma');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
				}).finally(() => {
					
				});

			}else {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'CambioForma');
				this.detallePedido = result;

				this.objPedido.EscanearForma 	= '';
				this.objPedido.MontarArmazon 	= '';
				this.objPedido.AumentarMedida 	= 'NO';
				this.objPedido.AumentarArriba 	= '';
				this.objPedido.AumentaAbajo 	= '';
				this.objPedido.AumentaDerecho 	= '';
				this.objPedido.Contorno 		= '';

				this.calculaCostos();
			}
		},

		// OBTIENE POR API LOS BISELES DISPONIBLES PARA EL ARTICULO WEB
		getColoresTinte() {
			console.log('Obteniendo Tinte');			
			this.ListaColores = [];

			this.$http.get('/colores',{
				params:{
					EnPedido: 'SI'
				}
			})
			.then( res => {	
				this.ListaColores = res.data.data.data.map(item => 
					({
						IdColor: item.IdColor,
						Nombre: item.Nombre,
						Color: item.Color,
						EnPedido: item.EnPedido,
						EnLenteC: item.EnLenteC,
						Disponible: 'NO',
					})
				);
			}).catch( err => {
				console.log(err);
			});
			
		},

		calculaCostoEntintado() {
			let newRequest = {
				
				Procedimiento: 'Tinte',
				IdCliente: this.objCliente.IdCliente,
				//IdRecubrimiento: this.objPedido.IdRecubrimiento,
				
			};

			if( this.objPedido.ReqTinte == true ) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Tinte');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
				}).finally(() => {
					
				});

			}else {
				this.objPedido.IdColor 		= 0;
				this.objPedido.Tono 		= 0;
				this.objPedido.Coloracion 	= 0;

				const result = this.detallePedido.filter((item) => item.TipoDet != 'Tinte');
				this.detallePedido = result;

				this.calculaCostos();
			}
		},

		//*********************************** PROCESO PARA LENTES TERMINADOS *****************************
		
		viewLentesOrMateriales(pRecovery = false) {
			if(this.procesoActivo == 1) {
				this.limpiarConfLente('articuloweb',pRecovery)
				this.getMateriales();
				

			}else if (this.procesoActivo == 2 && pRecovery == false) {

				if(this.objPedido.NumPar == 1) {
					this.showTablaConfigLentes 	= true;
					this.objPedido.OjoDerecho 	= true;
					this.objPedido.OjoIzquierdo = true;
					this.blockBtnCalculaLT 		= true;
					this.limpiaRXDerecho(2);
					this.limpiaRXIzquierdo(2);
					this.desblockBtnLT(1);
					this.getEsferasxCilindrosLentes();

				}else if (this.objPedido.NumPar == 2) {
					this.limpiaLentesTerminados(2);
					this.bndBlockInputsConfig = true;
					this.preverificadorArticuloMLT();
				}
				
			}else if(this.procesoActivo == 3 && pRecovery == false) {
				this.blockCilindro = false;
				this.preverificadorArticulo();
			}
		},

		// RECUPERA LAS LISTAS DE ESFERAS Y CILINDROS QUE TENGA CONFIGURADO EL ARTICULO WEB
		getEsferasxCilindrosLentes(pRecovery = false) {
			console.log('Obteniendo EsferasxCilindros');

			if(parseInt(this.objPedido.IdArticuloWeb) > 0) {
				let array = this.ListaArticulosWeb.filter(item => item.IdArticuloWeb == this.objPedido.IdArticuloWeb);

				if(array != undefined && array.length > 0) {
					this.articuloWebSelect = array[0];

					this.ListaEsferasSelect 		= [];
					this.ListaEsferasxCilindrosLT 	= [];
					this.blockEsfera 				= false;

					let newRequest = {
						ArticuloWeb: this.articuloWebSelect,
					};

					this.$http.post('/opgetesferasxlentes', newRequest)
					.then( res => {
						this.ListaEsferasSelect			= res.data.data.Esferas;
						this.ListaEsferasxCilindrosLT 	= res.data.data.EsferasxCilindros;
						this.ListaColoresLenteC			= res.data.data.Colores;
						const Ejes						= res.data.data.Eje;
						const Adicion					= res.data.data.Adicion;

						Ejes.forEach(element => {
							this.ListaEjesLenteC.push({
								id: element.Valor,
								label: element.Valor+'°',
							});
						});

						Adicion.forEach(element => {
							this.ListaAdicionLenteC.push({
								id: element.Valor,
								label: element.Valor,
							});
						});


						// LENTES TERMINADOS - PROCESO 2
						if(this.procesoActivo == 2 && pRecovery) {
							this.getEsferaxCilindros('DER', true);
							this.getEsferaxCilindros('IZQ', true);
						}

						if(this.procesoActivo == 2 && this.objPedido.NumPar == 2) {
							this.bndBlockInputsConfig = false;
						}

						// LENTES DE CONTACTO - PROCESO 3
						if(this.procesoActivo == 3 ) {
							if(this.ListaColoresLenteC.length > 0) {
								this.bndBlockLenteC = true;
								this.bndLentCUseColors = true;
					
							}else {
								this.bndBlockLenteC = false;
								this.bndLentCUseColors = false;
							}

							if(this.ListaEsferasSelect.length == 1) {
								if(this.ListaEsferasSelect[0].RangoEsfera == '0.00') {
									this.objTblLenteContacto.Esfera = this.ListaEsferasSelect[0].RangoEsfera;
									this.blockEsfera = true;
									this.getEsferaxCilindros('MULTLC',false,false);
								}
							}
						}

					}).catch( err => {
						console.log(err);
					});
				}
			}
		},
		
		// VERIFICA EL CAMBIO DE VALOR DE ESFERA Y FILTRA LOS CILINDROS QUE CORRESPONDEN A LA ESFERA.
		getEsferaxCilindros(pLado = '', pRecovery = false, pCleanDetalle = true){
			
			if(pLado != undefined && pLado != '') {

				if(pRecovery) {
					this.bndCalculoPrecioLT = true;

				}else {
					this.bndCalculoPrecioLT = false; // RETORNAMOS A FALSE PORQUE SE REQUIERE DE VOLVER A CALCULAR EL COSTO, SI SE CAMBIA UN VALOR
					
					if( pCleanDetalle ) {
						const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');
						if(result != undefined) {
							this.detallePedido = result;
							this.calculaCostos();
						}
					}
				}

				let pRangoEsfera = '';
				if(pLado == 'DER') {
					if(pRecovery == false) {
						this.objPedido.OdCilindro = '';
						this.blockBtnCalculaLT = true;
					}
					pRangoEsfera = this.objPedido.OdEsfera;

					let result = this.ListaEsferasxCilindrosLT.filter( item => item.RangoEsfera == pRangoEsfera);
					if(result != undefined && result.length > 0) {
						this.ListaCilindrosSelect.Derecho = result[0].CilindrosDiponibles;
					}else {
						this.ListaCilindrosSelect.Derecho = [];
					}

				}else if (pLado == 'IZQ') {
					if(pRecovery == false) {
						this.objPedido.OiCilindro = '';
						this.blockBtnCalculaLT = true;
					}
					pRangoEsfera = this.objPedido.OiEsfera;

					let result = this.ListaEsferasxCilindrosLT.filter( item => item.RangoEsfera == pRangoEsfera);
					if(result != undefined && result.length > 0) {
						this.ListaCilindrosSelect.Izquierdo = result[0].CilindrosDiponibles
					}else {
						this.ListaCilindrosSelect.Izquierdo = [];
					}
				}else if (pLado == 'MULT') { // PARA MULTIPLES LENTES TERMINADO

					this.objTblLenteTerminado.ValCilindro = '';
					pRangoEsfera = this.objTblLenteTerminado.ValEsfera;

					let result = this.ListaEsferasxCilindrosLT.filter( item => item.RangoEsfera == pRangoEsfera);
					if(result != undefined && result.length > 0) {
						this.ListaCilindrosSelect.Multiple = result[0].CilindrosDiponibles
					}else {
						this.ListaCilindrosSelect.Multiple = [];
					}

				}else if (pLado == 'MULTLC') { // PARA LENTES DE CONTACTO
					this.objTblLenteContacto.Cilindro = '';
					pRangoEsfera = this.objTblLenteContacto.Esfera;
					this.blockCilindro = false;

					let result = this.ListaEsferasxCilindrosLT.filter( item => item.RangoEsfera == pRangoEsfera);
					//console.log(result);
					if(result != undefined && result.length > 0) {

						// SE VERIFICA SI HAY MAS DE UN CILINDRO, NO SE BLOQUEA EL CAMPO
						if(result[0].CilindrosDiponibles.length > 1) {
							this.ListaCilindrosSelect.Multiple = result[0].CilindrosDiponibles

						}else {
							this.ListaCilindrosSelect.Multiple 	= result[0].CilindrosDiponibles

							// VERIFICAMOS SI ESA UNICA OPCION DISPONIBLE ES EL VALOR 0.00, SE ESTABLECE Y BLOQUEAMOS EL USO DEL CILINDRO
							if(result[0].CilindrosDiponibles[0].RangoCilindro == '0.00') {
								this.objTblLenteContacto.Cilindro 	= result[0].CilindrosDiponibles[0].RangoCilindro;
								this.blockCilindro = true;
							}
							
						}
						
					}else {
						this.ListaCilindrosSelect.Multiple = [];
					}
				}
				

			}else {
				this.bndCalculoPrecioLT = false; // RETORNAMOS A FALSE PORQUE SE REQUIERE DE VOLVER A CALCULAR EL COSTO, SI SE CAMBIA UN VALOR
				if(pLado == 'DER') {
					this.ListaCilindrosSelect.Derecho = [];

				}else if (pLado == 'IZQ') {
					this.ListaCilindrosSelect.Izquierdo = [];
				}else if (pLado == 'MULT') {
					this.ListaCilindrosSelect.Multiple = [];
				}
			}

		},

		// VALIDA EL LLENADO DE LOS CAMPOS DE ESFERA, CILINDRO Y EJE PARA PODER DESBLOQUEAR EL BTN DE CALUCLO
		desblockBtnLT(pOp = 0){
			console.log('DesblockLT se activa');
			if(pOp > 0) {
				this.bndCalculoPrecioLT = false; // RETORNAMOS A FALSE PORQUE SE REQUIERE DE VOLVER A CALCULAR EL COSTO, SI SE CAMBIA UN VALOR
				this.blockBtnCalculaLT = true;
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');

				if(result != undefined) {
					this.detallePedido = result;
					this.calculaCostos();
				}
			
			}

			let bnd1 = 0;
			let bnd2 = 0;

			// VAL LADO DERECHO
			if(this.objPedido.OjoDerecho == true) {

				if(this.objPedido.OdEsfera != '' && this.objPedido.OdEsfera != undefined) {
					bnd1++;
				}

				if(this.objPedido.OdCilindro != '' && this.objPedido.OdCilindro != undefined) {
					bnd1++;

					if(this.objPedido.OdEje != '' && this.objPedido.OdEje != undefined) {
						bnd1++;
					}else {
						this.bndCalculoPrecioLT = false;
						this.blockBtnCalculaLT = true;
						this.toolTipRX.showToolOdEjeRequire = true
					}

				}
			}

			// VAL LADO IZQUIERDO
			if(this.objPedido.OjoIzquierdo == true) {

				if(this.objPedido.OiEsfera != '' && this.objPedido.OiEsfera != undefined) {
					bnd2++;
				}

				if(this.objPedido.OiCilindro != '' && this.objPedido.OiCilindro != undefined) {
					bnd2++;

					if(this.objPedido.OiEje != '' && this.objPedido.OiEje != undefined) {
						bnd2++;

					}else {
						this.bndCalculoPrecioLT = false;
						this.blockBtnCalculaLT = true;
						this.toolTipRX.showToolOiEjeRequire = true
					}

				}
			}
			
			// SI AMBOS OJOS ESTAN ACTIVOS, POR LEY SE REQUIERE QUE ESTEN COMPLETOS LOS 3 CAMPOS DE CADA UNO
			if(this.objPedido.OjoDerecho == true && this.objPedido.OjoIzquierdo == true){
				if(bnd1 == 3 && bnd2 == 3) {
					this.blockBtnCalculaLT = false;
				}else {
					this.blockBtnCalculaLT = true;
				}

			}else {
				// EN CASO DE QUE SEA SOL UN OJO, UNICAMENTE SE VALIDA QUE TENGA LOS 3 CAMPOS UNO U OTRO
				if(bnd1 == 3 || bnd2 == 3) {
					this.blockBtnCalculaLT = false;
				}else {
					this.blockBtnCalculaLT = true;
				}
			}

			return {
				ODerecho: this.objPedido.OjoDerecho,
				BndDerecho: bnd1,
				OIzquierdo: this.objPedido.OjoIzquierdo,
				BndIzquierdo: bnd1,
			}
			
		},

		calculaCostosLenteTerminado() {
			this.calculaCostosProtecciones();
		},

		desblockBtnMLT(){
			if(this.objTblLenteTerminado.ValEsfera != '') {
				if(this.objTblLenteTerminado.ValCilindro != '') {
					if( parseInt(this.objTblLenteTerminado.Cantidad) > 0){
						this.bndBlockLenteT = false;
					}
				}
			}
		},

		async agregarMultLentes() {
			
			this.objTblLenteTerminado.IdArticuloWeb = this.objPedido.IdArticuloWeb;

			let bndCount = 0;
			let bndResponse = false;

			if(this.objTblLenteTerminado.IdArticuloWeb > 0) {
				bndCount++;
				// VALIDACIONES ESTADAR DE LA
				if (this.objTblLenteTerminado.ValEsfera != '' && this.objTblLenteTerminado.ValEsfera != undefined) {
					bndCount++;
					if(this.objTblLenteTerminado.ValCilindro != '' && this.objTblLenteTerminado.ValCilindro != undefined) {
						bndCount++;
						if(parseInt(this.objTblLenteTerminado.Cantidad) > 0 && this.objTblLenteTerminado.Cantidad != '') {
							bndResponse = true;

						}else { this.$toast.info('Requiere indicar la cantidad requerida');}
					}else {this.$toast.info('Requiere seleccionar un valor de Cilindro');}
				}else { this.$toast.info('Requiere seleccionar un valor de Esfera');}
			}

			if(bndResponse === false && bndCount == 0) {
				this.$toast.info('Requiere completar los datos para poder agregar el articulo');
				return false;
			}else if(bndResponse === false ) {
				return false;
			}

			const cant = this.objTblLenteTerminado.Cantidad;
			let array = {
				IdArticuloWeb: 	this.objPedido.IdArticuloWeb,
				Descripcion:	this.articuloWebSelect.Nombre,
				ValEsfera: 		this.objTblLenteTerminado.ValEsfera,
				ValCilindro: 	this.objTblLenteTerminado.ValCilindro,
				Cantidad: 		cant,
			}
			this.listaDetalleLT.push(array);

			await this.verificarProductos();
			this.objTblLenteTerminado.Cantidad = 0;
				
		
		},

		// PRE-VALIDADOR DE ARTICULO WEB DISPONIBLE
		async preverificadorArticuloMLT() {


			if(parseInt(this.objPedido.IdArticuloWeb) > 0) {
				let array = this.ListaArticulosWeb.filter(item => item.IdArticuloWeb == this.objPedido.IdArticuloWeb);

				if(array != undefined && array.length > 0) {
					this.articuloWebSelect = array[0];
				}
			}

			let newRequest = {
				Procedimiento: 'Proteccion',
				ArticuloWeb: this.articuloWebSelect,
				TipoLente: this.TpLenteSelect,
				IdCliente: this.objCliente.IdCliente,
				IdMaterial: 0,
				IdSubLinea: 0,
				IdProteccion:0,
				OjoDerecho: 'NO',
				OjoIzquierdo: 'NO',
				//SECCION PARA LENTES TERMINADOS
				NumPares: 2,
				CantidadTotal: 1
			};

			
			await this.$http.post('/opgetcostos', newRequest)
			.then( res => {

				let promesas = [];
				promesas.push(this.limpiaLentesTerminados(2));
				promesas.push(this.getEsferasxCilindrosLentes());
				return Promise.all(promesas);	
			})
			.catch( err => {
				console.log(err);
				this.bndBlockLenteT 		= true;
				this.bndBlockInputsConfig 	= true;
				this.limpiaLentesTerminados(2);
				this.$toast.error('El articulo seleccionado no esta disponible');
				
			})

		},

		async verificarProductos(tipo = 1, pisClenaDet = false, tpSubClean = 1) {

			// SE RECORRE LA LISTA DE PEDIDOS AGREGADOS A LA ORDEN DE COMPRA
			let array = (tipo == 1) ? this.listaDetalleLT : this.listaDetalleLenteC;
			let ziseTbl = array.length;
			let cont = 1;

			this.detallePedido.forEach( (element) => {
				element.Cantidad  = 0;
			});

			console.log('check articulos det');
			array.forEach( (element) => {

					// SE VERIFICA SI EL PRODUCTO DEL DETALLE DEL PEDIDO, YA SE ENCUENTRA EN LA LISTA DE PRODUCTOS PARA LA ORDEN
					let arr = this.detallePedido.filter(function(item,index) {
						if(item.IdArticuloWeb == element.IdArticuloWeb){
							return item;
						} else {
							return '';
						}
					});

					// SI EL ARTICULO YA EXISTE EN LA LISTA GENERAL DEL PEDIDO, SE PROCEDE A SUMAR LA CANTIDAD DEL ARTICULO YA REPETIDO
					// DE FORMA QUE AUMENTE LA CANTIDAD DEL ARTICULO REPETIDO CON FORME A LA CANTIDAD SOLICITADA EN EL PEDIDO
					if(arr[0]) {
						console.log('articulo repetido detectado')
						const IdArticuloWeb = arr[0].IdArticuloWeb;
						const index = this.detallePedido.findIndex(item => parseInt(item.IdArticuloWeb) === IdArticuloWeb);


						if(index !== -1) {
							this.detallePedido[index].Cantidad = ( parseFloat(this.detallePedido[index].Cantidad) + parseFloat(element.Cantidad) );
							this.detallePedido[index].Importe  = ( parseFloat(this.detallePedido[index].Cantidad) * parseFloat(this.detallePedido[index].Precio) );
						}

					}else {
						// SI EL PRODUCTO NO EXISTE EN LA LISTA DE PRODUCTOS GENERALES DE LA ORDEN, SE PROCEDE A AGREGARLO DIRECTAMENTE A LA LISTA
						let promesas = [];
						let newRequest = {
				
							Procedimiento: 'Proteccion',
							ArticuloWeb: this.articuloWebSelect,
							TipoLente: this.TpLenteSelect,
							IdCliente: this.objCliente.IdCliente,
							IdMaterial: 0,
							IdSubLinea: 0,
							IdProteccion:0,
							OjoDerecho: 'NO',
							OjoIzquierdo: 'NO',
							
							//SECCION PARA LENTES TERMINADOS
							NumPares: 2,
							CantidadTotal: element.Cantidad
							
						};

						promesas.push(
							this.$http.post('/opgetcostos', newRequest)
							.then( res => this.detallePedido.push(res.data.data) )
							.catch( err => console.log(err) )
						)

						return Promise.all(promesas);						
					}				
					cont++;
			});

			if(ziseTbl == cont) {
				this.$toast.success('Pedido Agregado','','');
				if(pisClenaDet) {
					this.limpiaLenteContacto(tpSubClean);
				}
				
			}
			
		},

		async eliminarMulLentes(indx, pIdArticulo = 0) {
			this.listaDetalleLT.splice( indx, 1 );

			if(this.listaDetalleLT.length == 0) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');

				if(result != undefined) {
					this.detallePedido = result;
					this.calculaCostos();
				}
			}else {
				await this.verificarProductos();
			}

			// LIMPIA EL DETALLE DE ELEMENTOS CON CANTIDAD 0, POSTERIORMENTE A LA VERIFICACION DE PRODUCTOS
			const result = this.detallePedido.filter((item) => parseInt(item.Cantidad) > 0);
			if(result != undefined) {
				this.detallePedido = result;
				this.calculaCostos();
			}
		},

		limpiaLentesTerminados(op = 1) {
			if(op == 1) { // parcial - agregados de articulos
				this.objTblLenteTerminado.Cantidad 		= 0;

			}else if(op == 2) { // Total - cambios de articulo
				this.objTblLenteTerminado = {
					ValEsfera: '',
					ValCilindro: '',
					Cantidad: 0,
				};
			}
		},

		mapLentesTerminados(detalle) {

			if(detalle != undefined && detalle != null) {
				if(detalle.length > 0) {
					this.listaDetalleLT = detalle.map(item => 
						({
							IdArticuloWeb: 	item.IdArticuloWeb,
							Descripcion:	'',
							ValEsfera: 		item.Esfera,
							ValCilindro: 	item.Cilindro,
							Cantidad: 		item.Cantidad,
						})
					);

					this.listaDetalleLT.forEach( (element) => {

						// SE VERIFICA SI EL PRODUCTO DEL DETALLE DEL PEDIDO, YA SE ENCUENTRA EN LA LISTA DE PRODUCTOS PARA LA ORDEN
						let arr = this.detallePedido.filter(function(item,index) {
							if(item.IdArticuloWeb == element.IdArticuloWeb){
								return item;
							} else {
								return '';
							}
						});

						if(arr[0]) {
							const IdArticuloWeb = arr[0].IdArticuloWeb;
							const index = this.detallePedido.findIndex(item => parseInt(item.IdArticuloWeb) === IdArticuloWeb);
							element.Descripcion = this.detallePedido[index].Descripcion;
						}

					});


				}
			}
			
		},

		//*********************************** PROCESO PARA LENTES DE CONTACTO *****************************
		
		setColorLentC(item) {
			this.objTblLenteContacto.Cantidad = 0;
			if(item != undefined && item != '') {
				this.objTblLenteContacto.IdColor 		= item.IdColor;
				this.objTblLenteContacto.NombreColor 	= item.Nombre;
				this.objTblLenteContacto.Color 			= item.Color;
				this.bndBlockLenteC = false;
			}else {
				this.objTblLenteContacto.IdColor 		= 0;
				this.objTblLenteContacto.NombreColor 	= '';
				this.objTblLenteContacto.Color 			= '';
				this.$toast.warning('No se ha podido seleccionar el color');
			}
		},

		async agregarLenteContacto() {
			this.objTblLenteContacto.IdArticuloWeb 	= this.objPedido.IdArticuloWeb;
			this.objTblLenteContacto.Descripcion 	= this.articuloWebSelect.Nombre;

			let bndCount = 0;
			let bndResponse = false;

			if(this.objTblLenteContacto.IdArticuloWeb > 0) {

				// VALIDACIONES ESTADAR DE LA
				if (this.objTblLenteContacto.Esfera != '' && this.objTblLenteContacto.Esfera != undefined) {
					if(this.objTblLenteContacto.Cilindro != '' && this.objTblLenteContacto.Cilindro != undefined) {
						if(parseInt(this.objTblLenteContacto.Cantidad) > 0 && this.objTblLenteContacto.Cantidad != '') {
							bndCount++;
						}
					}
				}

				if(bndCount == 1 && this.bndLentCUseColors && this.objTblLenteContacto.IdColor != '' && parseInt(this.objTblLenteContacto.IdColor) > 0) {
	
					bndResponse = true;

					if(this.articuloWebSelect.ReqEjeAdd == 'Eje' &&  (this.objTblLenteContacto.Eje == '' || parseInt(this.objTblLenteContacto.Eje) == 0) ) {
						bndResponse = false;	
					}

					if(this.articuloWebSelect.ReqEjeAdd == 'Adicion' &&  (this.objTblLenteContacto.Adicion == '' || this.objTblLenteContacto.Adicion == undefined) ) {
						bndResponse = false;
					}
					
				}else if(bndCount == 1) {
					bndResponse = true;

					if(this.articuloWebSelect.ReqEjeAdd == 'Eje' &&  (this.objTblLenteContacto.Eje == '' || parseInt(this.objTblLenteContacto.Eje) == 0) ) {
						bndResponse = false;	
					}

					if(this.articuloWebSelect.ReqEjeAdd == 'Adicion' &&  (this.objTblLenteContacto.Adicion == '' || this.objTblLenteContacto.Adicion == undefined) ) {
						bndResponse = false;
					}
				}
			}

			if(bndResponse === false) {
				this.$toast.info('Requiere completar los datos para poder agregar el articulo');
				return false;
			}

			let array = {
				IdArticuloWeb: 	this.objTblLenteContacto.IdArticuloWeb,
				IdColor:		this.objTblLenteContacto.IdColor,
				NombreColor:	this.objTblLenteContacto.NombreColor,
				Color:			this.objTblLenteContacto.Color,
				Descripcion:	this.objTblLenteContacto.Descripcion,
				Esfera: 		this.objTblLenteContacto.Esfera,
				Cilindro: 		this.objTblLenteContacto.Cilindro,
				Eje:			this.objTblLenteContacto.Eje,
				Adicion:		this.objTblLenteContacto.Adicion,
				Cantidad: 		this.objTblLenteContacto.Cantidad,
			}
			
			this.listaDetalleLenteC.push(array);
			await this.verificarProductos(2,true,1);
			

		},

		limpiaLenteContacto(op = 1) {
			if(op == 1) { // parcial - agregados de articulos
				this.objTblLenteContacto.IdArticuloWeb 	= 0;
				this.objTblLenteContacto.IdColor 		= 0;
				this.objTblLenteContacto.NombreColor 	= '';
				this.objTblLenteContacto.Color 			= '';
				this.objTblLenteContacto.Descripcion 	= '';
				this.objTblLenteContacto.Eje 			= '';
				this.objTblLenteContacto.Adicion 		= '';
				this.objTblLenteContacto.Cantidad 		= 0;

			}else if(op == 2) { // Total - cambios de articulo
				this.objTblLenteContacto = {
					IdArticuloWeb: 0,
					IdColor: 0,
					NombreColor: '',
					Color: '',
					Descripcion: '',
					Esfera: '',
					Cilindro: '',
					Eje: '',
					Adicion: '',
					Cantidad: 0,
				};
			}
		},

		eliminarLentesContacto(idex){
			this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value){ 
					this.eliminaLC(idex)
				}
			});
		},

		async eliminaLC(indx) {
		
			this.listaDetalleLenteC.splice( indx, 1 );

			if(this.listaDetalleLenteC.length == 0) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');

				if(result != undefined) {
					this.detallePedido = result;
					this.calculaCostos();
				}
			}else {
				await this.verificarProductos(2);
			}

			// LIMPIA EL DETALLE DE ELEMENTOS CON CANTIDAD 0, POSTERIORMENTE A LA VERIFICACION DE PRODUCTOS
			const result = this.detallePedido.filter((item) => parseInt(item.Cantidad) > 0);
			if(result != undefined) {
				this.detallePedido = result;
				this.calculaCostos();
			}

			this.$toast.success('Registro eliminado');
			
		},
		// PRE-VALIDADOR DE ARTICULO WEB DISPONIBLE
		async preverificadorArticulo() {


			if(parseInt(this.objPedido.IdArticuloWeb) > 0) {
				let array = this.ListaArticulosWeb.filter(item => item.IdArticuloWeb == this.objPedido.IdArticuloWeb);

				if(array != undefined && array.length > 0) {
					this.articuloWebSelect = array[0];
				}
			}

			let newRequest = {
				Procedimiento: 'Proteccion',
				ArticuloWeb: this.articuloWebSelect,
				TipoLente: this.TpLenteSelect,
				IdCliente: this.objCliente.IdCliente,
				IdMaterial: 0,
				IdSubLinea: 0,
				IdProteccion:0,
				OjoDerecho: 'NO',
				OjoIzquierdo: 'NO',
				//SECCION PARA LENTES TERMINADOS
				NumPares: 2,
				CantidadTotal: 1
			};

			
			await this.$http.post('/opgetcostos', newRequest)
			.then( res => {

				let promesas = [];
				promesas.push(this.limpiaLenteContacto(2));
				promesas.push(this.getEsferasxCilindrosLentes(2));
				return Promise.all(promesas);	
			})
			.catch( err => {
				console.log(err);
				this.bndLentCUseColors 	= false;
				this.bndBlockLenteC 	= true;
				this.limpiaLenteContacto(2);
				this.$toast.error('El articulo seleccionado no esta disponible');
				
			})

		},

		mapLentesContacto(detalle) {

			if(detalle != undefined && detalle != null) {
				if(detalle.length > 0) {
					this.listaDetalleLenteC = detalle.map(item => 
						({
							IdArticuloWeb: 	item.IdArticuloWeb,
							IdColor:		item.IdColor,
							NombreColor:	item.NombreColor,
							Color:			item.Color,
							Descripcion:	'',
							Esfera: 		item.Esfera,
							Cilindro: 		item.Cilindro,
							Eje: 			item.Eje,
							Adicion: 		item.Adicion,
							Cantidad: 		item.Cantidad,
						})
					);

					this.listaDetalleLenteC.forEach( (element) => {

						// SE VERIFICA SI EL PRODUCTO DEL DETALLE DEL PEDIDO, YA SE ENCUENTRA EN LA LISTA DE PRODUCTOS PARA LA ORDEN
						let arr = this.detallePedido.filter(function(item,index) {
							if(item.IdArticuloWeb == element.IdArticuloWeb){
								return item;
							} else {
								return '';
							}
						});

						if(arr[0]) {
							const IdArticuloWeb = arr[0].IdArticuloWeb;
							const index = this.detallePedido.findIndex(item => parseInt(item.IdArticuloWeb) === IdArticuloWeb);
							element.Descripcion = this.detallePedido[index].Descripcion;
						}

					});

				}
			}

		},

    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);

		let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        
        if(Origen != undefined && Origen != null && Origen != '' ) {
            
            this.oBtnSave.ReturnRoute = (Origen == 'Cotizaciones') ? 'cotizaciones' : 'pedidos';
			
        }
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
		this.getListTiposLentes();

        if(this.Id !='' && this.Id != undefined && this.Id > 0) 
        {
            this.objPedido.IdPedido = this.Id;
            this.Recuperar();
			this.cambiarPaso(1);
        }
		else {	
		
			//this.ConfigList.Title = (this.oBtnSave.ReturnRoute  == 'cotizaciones') ? 'Crear Nueva Cotizacion' : 'Crear Nuevo Pedido';	
			this.cambiarPaso(1);		
			this.ConfigLoad.ShowLoader = false;
		}

		if(this.Obj != '' && this.Obj != undefined) {
			this.locationForm = this.Obj;
		}else {
			if (sessionStorage.getItem('menuOrigen') != '' && sessionStorage.getItem('menuOrigen') != undefined) {
				this.locationForm = JSON.parse(sessionStorage.getItem('menuOrigen'));
			}else {
				this.locationForm = 'Cotizaciones';
			}
		}

        this.bus.$on('Save_'+this.Emit,()=>
        {	
			console.log('Guardando de Emit...');
            this.Guardar('Pendiente');
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

    },

	computed: {
		autoSuma() {

			if(this.procesoActivo == 2 && this.objPedido.NumPar == 2 && this.listaDetalleLT.length > 0) {
				let subtotal = 0;
				
				this.detallePedido.forEach((item) => {
					subtotal += parseFloat(item.Importe);
				});
				
				this.objPedido.SubTotal 	= subtotal;
				this.objPedido.Iva 			= (subtotal*0.16);
				this.objPedido.GranTotal 	= (subtotal + this.objPedido.Iva);

			}else if(this.procesoActivo == 3 && this.objPedido.NumPar == 2 && this.listaDetalleLenteC.length > 0) {
				let subtotal = 0;
				
				this.detallePedido.forEach((item) => {
					subtotal += parseFloat(item.Importe);
				});
				
				this.objPedido.SubTotal 	= subtotal;
				this.objPedido.Iva 			= (subtotal*0.16);
				this.objPedido.GranTotal 	= (subtotal + this.objPedido.Iva);
			}
			
			return this.detallePedido;
		},

		autoValidador() {
			if(this.procesoActivo > 0) {
				this.unlockBtnSave 			= false;
				this.oBtnSaveResumen.ShowBtnSave  	= false;

				switch (parseInt(this.procesoActivo)) {
					case 1:

						if(this.objPedido.IdSubLinea >= 0) {
							if(this.objPedido.IdArticuloWeb > 0) {
								if(this.objPedido.IdMaterial > 0) {
									if(this.objPedido.IdProteccion > 0 ) {
										const result = this.detallePedido.filter((item) => item.TipoDet == 'Proteccion');
										if(result != undefined && result.length > 0) {
											//console.log(result);
											//console.log('Si Existe registro de un articulo en el detalle');
											if(this.objPedido.IdRecubrimiento > 0) {
												if(this.objPedido.IdArmazon > 0) {
													if(this.objPedido.DBL != '' && this.objPedido.ED != '' && this.objPedido.B && this.objPedido.A){
														this.unlockBtnSave 	= true;
														this.oBtnSaveResumen.ShowBtnSave  	= true;
													}
												}
											}
										}
									}
								}
							}
						}	

						break;

					case 2:
						if( parseInt(this.objPedido.NumPar) == 1) {

							if(this.objPedido.IdCliente > 0) {
								if(this.objPedido.IdTipoLente > 0) {
									if(this.objPedido.IdArticuloWeb > 0) {
										if(this.detallePedido.length > 0) {
											// DESBLOQUEAMOS LOS BOTONES DEL SAVE
											this.unlockBtnSave 	= true;
											this.oBtnSaveResumen.ShowBtnSave  	= true;
										}
									}
								}
							}
							
						}else if( parseInt(this.objPedido.NumPar) == 2) {
							if(this.objPedido.IdCliente > 0) {
								if(this.objPedido.IdTipoLente > 0) {
									if(this.listaDetalleLT.length > 0) {
										if(this.detallePedido.length > 0) {
											// DESBLOQUEAMOS LOS BOTONES DEL SAVE
											this.unlockBtnSave 	= true;
											this.oBtnSaveResumen.ShowBtnSave  	= true;
										}
										
									}
								}
							}
							
						}

						break;

					case 3:
						
						if(this.objPedido.IdCliente > 0) { // SI HAY UN CLIENTE
							if(this.objPedido.IdTipoLente > 0) {	// SI EXISTE EL TIPO DE LENTE
								if(this.listaDetalleLenteC.length > 0) { // SI YA SE TIENE UNA SUBLISTA DE PEDIDO
									if(this.detallePedido.length > 0) { // SI YA SE TIENE AL MENOS UN DETALLE DE PEDIDO
										// DESBLOQUEAMOS LOS BOTONES DEL SAVE
										this.unlockBtnSave 	= true;
										this.oBtnSaveResumen.ShowBtnSave  	= true;
									}
								}
							}
						}
						
						break;
					
				}
			}
		}
		
	
	}
}
</script>
<style>
.IzEsferas{
	left: 220px !important;
}
.c-pop {
	right: 10px !important;
}

.popover-body {
    font-size: 13px !important;
}

.form-check:not(.form-switch) .form-check-input[type="radio"].lente:after {
  transition: opacity 0.25s ease-in-out;
  content: "";
  position: absolute;
  width: 0.4375rem;
  height: 0.4375rem;
  border-radius: 50%;
  background-color: transparent !important;
  opacity: 0;
}

.form-check:not(.form-switch) .form-check-input[type="radio"].lente:checked {
	padding-top: 4.3px !important;
    padding-right: 5.3px !important;
    padding-bottom: 5.3px !important;
    padding-left: 6.8px !important;
}

input[type="radio"].lente{
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #394e64;
    -webkit-box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.75);
    cursor: pointer;
}

input[type="radio"].lente{
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}
input[type="radio"].lente:checked:after{
    font-family: "Font Awesome 5 Pro" !important;
  	content: "\f00c" !important;
	color: white !important;
    
}
input[type="radio"].lente:focus{
    outline: none;
}
.form-check-input:checked[type="radio"].lente {
    background-image: none;
}
.form-check-input:checked[type=radio].lente {
    --bs-form-check-bg-image:none;
}

.btn-search {
    margin-bottom: 0 !important;
    text-transform: none;
    box-shadow: none !important;
    letter-spacing: 1px;
    font-weight: lighter !important;
	border-start-end-radius: 0;
	border: 1px solid #d2d6da !important;
}

.vs__dropdown-toggle {
	padding: 0.3rem 0.75rem !important;
    border-radius: 0.5rem !important;
}
.vs__actions {
	padding-top: 0 !important;
}
</style>
